import _ from "lodash";
import moment from "moment";
import { config } from '../constant';
import { ChatService } from '../chatService';
import { callSDK } from "unifiedring-sdk";
import store from "../../context/store/store";
import { closeVideoCallRinging, closeVideoRinging, Cookie, getcontactDetail, getCookie, getTeamMemberContact } from "../utils";
import { actionTypes, Types } from '../../context/action/action';
import { contacts, LoginState, UserDetails, workContact } from "../../models/model";
import { initializeRecognition, stopRecognition } from "./voiceSdkIntegration";
import {
  calldetail, closeCaptionmeetingState, conferenceDetailUserInfo, currentCallDetail
} from "../../models/callModel";
import { storeActiveLogs, storeParticularLog, urlTranscription } from "./store_mining";
import { contactService } from "../contactService";
import { clearUndotimeout, getCallLogsCDR, getRecordingLogs, getVoiceMailLogs } from "./callsApiService";
import { SocketChatService } from '../socketChatService';
import { generateChatID, userInfo } from '../socketChatService/utils';
import wordicon from '../../styles/images/wordicon.svg';
import pdficon from '../../styles/images/pdficon.svg';
import excelicon from '../../styles/images/excelicon.svg';
import powerpointicon from '../../styles/images/powerpointicon.svg';
import grid_image from '../../styles/images/grid_image.svg';
import grid_music from '../../styles/images/grid_music.svg';
import grid_zip from '../../styles/images/grid_zip.svg';
import { muteCall } from "./callService";
//import publicIp from "public-ip";
import axios from "axios";
import { saveAs } from "file-saver";
import { storePerformance, storeActions, storeEditMOM, storeEditMOMCopy, storeMOM, storeTranscript, storePlayListPage } from "../meetingService/meetingStoreServices";
import jsPDF from 'jspdf';
import JSZip from "jszip";
import { deleteRecord, updateMeetingRead } from "../meetingService/apiService";
import { log } from "console";
import { saverecordlist } from "../socketChatService/newChat";
const zip = new JSZip();
export const daysInWord = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const monthInWord = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];;
let { detailPage, meetingHighlights } = store.getState().meetingReducer;
let blobArr: any = [];
let textfile: any = [];
let mediaRecorder: any=null;
let timer: any;
export const getTimeFormat = (stamp: string) => {
  let day: Date = new Date(stamp);
  let min = day.getMinutes().toString().padStart(2, "0");
  let Bdate = day.getHours() + ":" + min;

  let time: any = Bdate.split(" ");
  let ampm: string;

  let [hours, minutes] = time[0].split(":");
  ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  time = hours + ":" + minutes + " " + ampm;

  return time;
};

export const getFileExt = (filename: any) => {
  const extension = filename.split('.').pop();
  return extension;
}

export const shortFileName = (filename: any) => {
  const fileName = filename.split('.');
  return fileName[0].length > 10 ? fileName[0].substring(0, 10) : fileName[0]
}

export const timeStampConverter = (stamp: string, format: string) => {
  try {
    let day: any = new Date(stamp);
    let min = day.getMinutes().toString().padStart(2, "0");
    let Bdate = day.getHours() + ":" + min;
    let time: any = Bdate.split(" ");
    let ampm: string;
    let [hours, minutes] = time[0].split(":");
    ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    time = hours + ":" + minutes + " " + ampm;
    let month: any = parseInt(day.getMonth()) + 1;
    let date: string =
      day.getDate().toString().length > 1 ? day.getDate() : "0" + day.getDate();
    month = month.toString().length > 1 ? month : "0" + month;
    let year = day.getFullYear();
    var curDate = new Date();
    let newdate = curDate.getFullYear() === year ? (date + " " + moment(new Date(day)).format("MMM")) :
      (date + " " + moment(new Date(day)).format("MMM") + " " + year);
    var Cdate = curDate.getDate() + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
    var Ydate = curDate.getDate() - 1 + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
    var Tomdate = curDate.getDate() + 1 + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
    var Tdate = day.getDate() + "-" + (day.getMonth() + 1) + "-" + day.getFullYear();
    var group = Tdate;
    if (format === 'group') {
      if (Cdate === Tdate) return group = "Today";
      else if (Ydate === Tdate) return group = "Yesterday";
      else if (Tomdate === Tdate) return group = "Tomorrow";
      return newdate;
    }
    else if (format === 'list') {
      if (Cdate === Tdate) return time;
      else if (Ydate === Tdate) return group = "Yesterday";
      else if (Tomdate === Tdate) return group = "Tomorrow";
      return newdate;
    }
    return newdate + " " + group;
  }
  catch (error) { logInfo("timeStampConverter error!!!", error); }

};

export const timeStampConverterMeeting = (stamp: string, format: string) => {
  try {
    let day: any = new Date(stamp);
    let min = day.getMinutes().toString().padStart(2, "0");
    let Bdate = day.getHours() + ":" + min;
    let time: any = Bdate.split(" ");
    let ampm: string;
    let dayName: any = moment(stamp).format('ddd');
    let monthName: any = moment(stamp).format('MMM');
    let [hours, minutes] = time[0].split(":");
    ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    time = hours + ":" + minutes + " " + ampm;
    let month: any = parseInt(day.getMonth()) + 1;
    let date: string =
      day.getDate().toString().length > 1 ? day.getDate() : day.getDate();
    month = month.toString().length > 1 ? month : "0" + month;
    let year = day.getFullYear();
    var curDate = new Date();
    let newdate = curDate.getFullYear() === year ? (dayName + "," + date + " " + monthName) :
      (dayName + "," + date + " " + monthName + " " + year);
    var Cdate = curDate.getDate() + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
    var Ydate = curDate.getDate() - 1 + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
    var Tomdate = curDate.getDate() + 1 + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
    var Tdate = day.getDate() + "-" + (day.getMonth() + 1) + "-" + day.getFullYear();
    var group = Tdate;
    if (format === 'group') {
      if (Cdate === Tdate) return group = "Today";
      else if (Ydate === Tdate) return group = "Yesterday";
      else if (Tomdate === Tdate) return group = "Tomorrow";
      return newdate;
    }
    else if (format === 'list') {
      if (Cdate === Tdate) return time;
      else if (Ydate === Tdate) return group = "Yesterday";
      else if (Tomdate === Tdate) return group = "Tomorrow";
      return newdate;
    }
    return newdate + " " + group;
  }
  catch (error) { logInfo("timeStampConverter error!!!", error); }

};

export const findHostNameYou = (list: any) => {
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let host:any="";
  let hostMeetingName = _.find(list?.participants, function (o) {
    if (o.roletype === 1 && o.sipid !== loggedUserDetails.sip_login_id){
      host=o?.name;
    }
     if(o.roletype === 1 && o.sipid === loggedUserDetails.sip_login_id){
host="You";
    }
  });
  return host;
}

export const findHostName = (list: any) => {
  let hostMeetingName = _.find(list, function (o) {
    return o.role_type === 1;
  });
  return hostMeetingName?.name;
}

export const findRecHost = (list: any) => {
  let hostMeetingName = _.find(list, function (o) {
    return o.role_type === 1;
  });
  return hostMeetingName?.name;
}

export const findCallHost = (ext: any) => {
  let contactReducer: contacts = store.getState().contactReducer || [];
  let companyContact: Array<workContact> = contactReducer?.workContacts || [];
  let callHostName:any=_.find(companyContact, function (o) {
   return o.ext?.toString() === ext;
  });
  return callHostName?.first_name;
}

/**
 * 
 *  To Start the timer for all calls including flip, normal and group call.
 */

export const startCallTime = (guid: string) => {

  try {
    let { activeLogs } = store.getState().callReducer || {};

    let activePos: number = activeLogs.findIndex(
      (ele: any) => ele.guid === guid
    );


    let currentCallList: any = store.getState().updatedCallList.callDetails || [];
    let callPos: number = currentCallList?.findIndex((e: any) => e?.guid === guid);
    //let alCallPos:number =activeLogs.findIndex((e:any) => e.guid === guid);
    if (activePos !== -1 || callPos !== -1) {
      let runtime:string=(currentCallList[callPos]?.isGroupCall && currentCallList[callPos]?.callduration) ? currentCallList[callPos]?.callduration : "00:00:00";
      timer = setInterval(() => {
        let activePos: number = activeLogs?.findIndex(
          (ele: any) => ele?.guid === guid
        );
        let callPos: number = currentCallList?.findIndex((e: any) => e?.guid === guid);
        runtime = CallTimer(runtime);
        if (activePos !== -1) {

          activeLogs[activePos].callduration = runtime
          storeActiveLogs(activeLogs);
        }
        if (callPos !== -1) {

          currentCallList[callPos].callduration = runtime


          store.dispatch({
            type: Types.UPDATDE_CALL_LIST,
            payloads: currentCallList
          });
        }
        if ((activeLogs[activePos]?.timer === -1 || currentCallList[callPos]?.timer === -1)) {
          clearInterval(timer);
        }
      }, 1000);
      if (activePos !== -1) { activeLogs[activePos].timer = timer; }
      if (callPos !== -1) { currentCallList[callPos].timer = timer; }

    }
  } catch (error) {
    console.log('startCallTime error is !!!', error)
  }

};

export const clearCallTimer=()=>{
  clearInterval(timer)
}



/**
 * 
 *  Duration formater for calls
 */

export const CallTimer = (initialDur: any) => {
  try {
    let ss: any = initialDur.split(":");
    let dt = new Date();
    dt.setHours(ss[0]);
    dt.setMinutes(ss[1]);
    dt.setSeconds(ss[2]);
    let dt2 = new Date(dt.valueOf() + 1000);
    let temp = dt2.toTimeString().split(" ");
    let ts = temp[0].split(":");
    let timer: any;
    timer = ts[0] + ":" + ts[1] + ":" + ts[2];
    return timer;
  } catch (error) { logInfo("CallTimer error is", error); }
};


/**
 * 
 *  RecordTimer for calls
 */
export const CallRecordTimer: any = (currentCallList: calldetail[], index: number) => {
  try {
    let ltime: string = currentCallList[index].recordDuration || '';
    ltime = ltime ? ltime : "00:00:00";

    let split: any = ltime.split(":");
    let newDate = new Date();
    newDate.setHours(split[0]);
    newDate.setMinutes(split[1]);
    newDate.setSeconds(split[2]);

    let dt2 = new Date(newDate.valueOf() + 1000);
    let temp = dt2.toTimeString().split(" ");
    let ts = temp[0].split(":");
    let timer: any;
    timer = ts[0] + ":" + ts[1] + ":" + ts[2];
    currentCallList[index].recordDuration = timer;
    store.dispatch({
      type: Types.UPDATDE_CALL_LIST,
      payloads: currentCallList
    });
  } catch (error) { logInfo("call recoding timer issue", ''); }
};

export const startRecordTimer: any = (guid: string) => {

  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
  let index: number = currentCallList.findIndex((e: calldetail) => e.guid === guid);

  if (index !== -1) {
    let timer: any;
    timer = setInterval(() => {
      CallRecordTimer(currentCallList, index);
    }, 1000);
    currentCallList[index].recTimer = timer;
  }
};

export const getTimeFormatAMPM = (splitHrMin: any, isAmPm: any) => {
  let timeFormat: any;
  if (isAmPm === "PM" && parseInt(splitHrMin[0]) < 12) {
    timeFormat = parseInt(splitHrMin[0]) + 12;
  }
  else if ((isAmPm === "AM" && parseInt(splitHrMin[0]) === 12)) {
    timeFormat = parseInt('00');
  }
  else if ((isAmPm === "PM" && parseInt(splitHrMin[0]) === 12)) {
    timeFormat = parseInt(splitHrMin[0]);
  }
  else if ((isAmPm === "AM" && parseInt(splitHrMin[0]) < 12)) {
    timeFormat = parseInt(splitHrMin[0]);
  }
  return timeFormat;
}

export const getHourFormat = (duration: any) => {
  let hours = ((duration) / 60);
  let getSplitted: any;
  if (hours.toString().includes(".5"))
    getSplitted = hours.toString().split(".");
  let hourss = (hours < 10 && hours.toString().includes(".5")) ? `0${getSplitted[0]}` : (hours > 10 && hours.toString().includes(".5")) ? `${getSplitted[0]}` : (hours > 10 && !hours.toString().includes(".5")) ? `${hours}` : `0${hours}`;
  let min = duration % 60;
  let minutes = (min < 10 && !min.toString().includes(".5")) ? `0${min}` : `30`;
  return `${hourss}:${minutes}`;
}
export const getCurrentTime=()=>{

  var interval = 30 * 60 * 1000; // 30 minutes in milliseconds
  let quarterHours:any = moment(new Date(Math.ceil(new Date().getTime() / interval) * interval)).format('hh:mm A').split(" ");
var timeString = quarterHours[0] ;
return timeString;
}
export const getMaxDurationFormat = (maxDuration: any) => {
  let maxDurate: any = maxDuration.split(":");
  let subsStringDuration: any = (parseInt(maxDurate[0])) < 10 ? maxDurate[0].substring(1) : maxDurate[0];
  let duration: any;
  if (maxDurate[1] === "00") {
    duration = `${subsStringDuration}h`
  }
  else if (maxDurate[0] === "00") {
    duration = `${maxDurate[1]}m`
  }
  else if (maxDurate[1] !== "00" && maxDurate[0] !== "00") {
    duration = `${subsStringDuration}h${maxDurate[1]}m`;
  }
  return duration;
}
export const convertDuration = (min: any) => {
  if(min >= 1){
    if (min > 60) {
      var minutes = min % 60;
      var hours = Math.floor(min / 60);
      return minutes !== parseInt("0") ? hours + "h" + minutes + "m" : hours + "h";
    }
    else {
      return min + "m";
    }
  }
    else{
      let sec = Math.round(min * 60 )
      return sec + "s";}
};

export const convertDurationSuggestions = (min: any) => {
  if(min >= 1){
    if (min > 60) {
      var minutes = min % 60;
      var hours = Math.floor(min / 60);
      return minutes !== parseInt("0") ? hours + "hrs" + minutes + "mins" : hours + "hrs";
    }
    else {
      return min + "mins";
    }
  }
    else{
      let sec = Math.round(min * 60 )
      return sec + "sec";}
};

export const convertDurationNotification = (min: any) => {
  if (min > 60) {
    var minutes = min % 60;
    var hours = Math.floor(min / 60);
    return hours + "Hrs" + minutes + "Min";
  }
  else {
    return min + " Min";
  }
};

export const searchAudioTranscript=(data:any,search:any)=>{
  if (search === "") { return; }
  else {
    let message = { firstMsg: "", middleMsg: "", lastMsg: "" };
    let tempSearch = search || '';
    let searchIndex = data?.finalText?.toLowerCase().indexOf(tempSearch.toLowerCase());
    if (data.finalText !== undefined && search !== undefined) {
      if (searchIndex !== -1) {
        message.firstMsg = data.finalText.substring(0, searchIndex);
        message.middleMsg = data.finalText.substring(searchIndex, searchIndex + search.length);
        message.lastMsg = data.finalText.substring(searchIndex + search.length);
      }
      return message;
    }
  } 
}
export const searchMeetingHighlight = (data: any, search: any) => {
  if (search === "") { return; }
  else {
    let message = { firstMsg: "", middleMsg: "", lastMsg: "" };
    let tempSearch = search || '';
    let searchIndex = data?.summary?.toLowerCase().indexOf(tempSearch.toLowerCase());
    if (data.summary !== undefined && search !== undefined) {
      if (searchIndex !== -1) {
        message.firstMsg = data.summary.substring(0, searchIndex);
        message.middleMsg = data.summary.substring(searchIndex, searchIndex + search.length);
        message.lastMsg = data.summary.substring(searchIndex + search.length);
      }
      return message;
    }
  }
};

export const searchAudioTranscriptName = (data: any, search: any) => {
  if (search === "") { return; }
  else {
    let message = { firstMsg: "", middleMsg: "", lastMsg: "" };
    let tempSearch = search || '';
    let searchIndex = data?.speakerName?.toLowerCase().indexOf(tempSearch.toLowerCase());
    if (data.speakerName !== undefined && search !== undefined) {
      if (searchIndex !== -1) {
        message.firstMsg = data.speakerName.substring(0, searchIndex);
        message.middleMsg = data.speakerName.substring(searchIndex, searchIndex + search.length);
        message.lastMsg = data.speakerName.substring(searchIndex + search.length);
      }
      return message;
    }
  }
};
export const searchTranscriptHighlight = (data: any, search: any) => {
  if (search === "") { return; }
  else {
    let message = { firstMsg: "", middleMsg: "", lastMsg: "" };
    let tempSearch = search || '';
    let searchIndex = data?.text?.toLowerCase().indexOf(tempSearch.toLowerCase());
    if (data.text !== undefined && search !== undefined) {
      if (searchIndex !== -1) {
        message.firstMsg = data.text.substring(0, searchIndex);
        message.middleMsg = data.text.substring(searchIndex, searchIndex + search.length);
        message.lastMsg = data.text.substring(searchIndex + search.length);
      }
      return message;
    }
  }
};

export const searchActionsHighlight = (data: any, search: any) => {
  if (search === "") { return; }
  else {
    let message = { firstMsg: "", middleMsg: "", lastMsg: "" };
    let tempSearch = search || '';
    let searchIndex = data?.actions?.toLowerCase().indexOf(tempSearch.toLowerCase());
    if (data.actions !== undefined && search !== undefined) {
      if (searchIndex !== -1) {
        message.firstMsg = data.actions.substring(0, searchIndex);
        message.middleMsg = data.actions.substring(searchIndex, searchIndex + search.length);
        message.lastMsg = data.actions.substring(searchIndex + search.length);
      }
      return message;
    }
  }
};

export const searchMeetingTitleHighlight = (data: any, search: any) => {
  if (search === "") { return; }
  else {
    let message = { firstMsg: "", middleMsg: "", lastMsg: "" };
    let tempSearch = search || '';
    let searchIndex = data?.title?.toLowerCase().indexOf(tempSearch.toLowerCase());
    if (data.title !== undefined && search !== undefined) {
      if (searchIndex !== -1) {
        message.firstMsg = data.title.substring(0, searchIndex);
        message.middleMsg = data.title.substring(searchIndex, searchIndex + search.length);
        message.lastMsg = data.title.substring(searchIndex + search.length);
      }
      return message;
    }
  }
};

export const searchMeetingDescriptionHighlight = (data: any, search: any) => {
  if (search === "") { return; }
  else {
    let message = { firstMsg: "", middleMsg: "", lastMsg: "" };
    let tempSearch = search || '';
    let searchDescriptionIndex = data?.description?.toLowerCase().indexOf(tempSearch.toLowerCase());
    if (data.description !== undefined && search !== undefined) {
      if (searchDescriptionIndex !== -1) {
        message.firstMsg = data.description.substring(0, searchDescriptionIndex);
        message.middleMsg = data.description.substring(searchDescriptionIndex, searchDescriptionIndex + search.length);
        message.lastMsg = data.description.substring(searchDescriptionIndex + search.length);
      }
      return message;
    }
  }
};

export const searchMeetingHostNameHighlight = (data: any, search: any) => {
  if (search === "") { return; }
  else {
    let message = { firstMsg: "", middleMsg: "", lastMsg: "" };
    let tempSearch = search || '';
    let searchhostNameIndex = data?.hostName?.toLowerCase().indexOf(tempSearch.toLowerCase());
    if (data.hostName !== undefined && search !== undefined) {
      if (searchhostNameIndex !== -1) {
        message.firstMsg = data.hostName.substring(0, searchhostNameIndex);
        message.middleMsg = data.hostName.substring(searchhostNameIndex, searchhostNameIndex + search.length);
        message.lastMsg = data.hostName.substring(searchhostNameIndex + search.length);
      }
      return message;
    }
  }
};

export const endRecordTimer: any = (guid: string) => {
  try {
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
    let index: number = currentCallList.findIndex((e: calldetail) => e.guid === guid);
    if (index !== -1) { clearInterval(currentCallList[index].recTimer); }
  }
  catch (error) { logInfo("endRecordTimer error is", error); }
};

export const getcallDetail = (viewData: any) => {
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let ext: string = (viewData.from_caller === loggedUserDetails.ext) ? viewData.to_caller : viewData.from_caller;
  let { logs }: any = store.getState().callReducer;


  let filterList: any = [];
  logs.forEach((element: any) => {
    if (element.from_caller === ext || element.to_caller === ext) {
      element.time = timeStampConverter(element.inserted_at, 'list');
      element.duration = callDuration(element.call_duration, element.bound);
      element.ext = ext;
      filterList.push(element);
    }
  });
  return filterList || [];
};

//coverts millisec to required New UI time format
export const milliSecondsConverter = (millis: any) => {
  let sec: any = Math.floor(millis / 1000);
  let hr: any = Math.floor(sec / 3600);
  sec -= hr * 3600;
  let min: any = Math.floor(sec / 60);
  sec -= min * 60;
  if (hr === 0 && min === 0) return sec + ' sec';
  else if (hr === 0) return min + ' mins ';
  else if (hr !== 0) return hr + " hrs ";
};

export const callDuration = (duration: any, bound?: string) => {
  try {
    if (duration !== undefined && duration !== "") {
      let str: string = "";
      if (bound === config().CALL_LOG_MISSED) {
        return "-";
      }
      else {
        let split: any = duration.split(":");
        if (split[0] !== "00") { str = split[0][1] + " hr"; }
        if (split[1] !== "00") { str += split[1] + " mins"; }
        if (str === "") { str = (split[2][0] === 0 ? "" : split[2][0]) + split[2][1] + " secs"; }
        return str;
      }
    }
    else { return "-"; }
  }
  catch (error) {
    if (bound === config().CALL_LOG_MISSED) { return "-"; }
    else { return "0 secs"; }
  }
};



export const determineIps = async () => {
  let PublicIp = ''
  let ipVersion = 'v4';
  return fetch('https://getip.worktual.co.uk/')
    .then(response => response.text()).then((data: any) => {
      PublicIp = (JSON.parse(data)).clientIPv6
      if (PublicIp.includes(":")) {
        PublicIp = "[" + PublicIp + "]";
        ipVersion = 'v6';
      }
      let existingIp: any = localStorage.getItem('IP');
      let isIPChanged: boolean = existingIp !== PublicIp
      localStorage.setItem('IP', PublicIp);
      localStorage.setItem('IPVersion', ipVersion);
      return { IP: PublicIp, IPVersion: ipVersion, isIPChanged: isIPChanged }
    }).catch(error => console.error(error));

};

export const updateCCToast = (message: string, timer?: number) => {
  store.dispatch({
    type: Types.CC_TOAST,
    payload: {
      ccMessage: message,
      ccToast: true
    }
  });
  setTimeout(function () {
    store.dispatch({
      type: Types.CC_TOAST,
      payload: {
        ccMessage: '',
        ccToast: false
      }
    });
  }, 5000);
}

export const toastMessageCallWindow = (message: string, timer?: number) => {
  store.dispatch({
    type: Types.SHOW_ERROR,
    payloads: {
      message: message,
      isToast: true
    }
  });



  setTimeout(function () {
    store.dispatch({
      type: Types.SHOW_ERROR,
      payloads: {
        message: '',
        isToast: false
      }
    });
  }, timer || 3000);
};

export const toastInformation = (message?: string, mode?: string) => {
  store.dispatch({
    type: Types.TOAST_INFO,
    payloads: {
      message: message,
      mode: mode,
      isLeftToast: true
    }
  });

  setTimeout(function () {
    store.dispatch({
      type: Types.TOAST_INFO,
      payloads: {
        message: message,
        mode: mode,
        isLeftToast: false
      }
    });
  }, 5000);
};



export const undoToastInfo = (isLeftToast: any, isEnableUndo: any, undoIt: any) => {
  store.dispatch({
    type: Types.UNDO_TOAST,
    payloads: {
      isLeftToast: isLeftToast,
      isEnableUndo: isEnableUndo,
      undoIt: undoIt
    }
  });

  if (undoIt) {
    clearUndotimeout();
  }
};

export const getVmTranscript=(Vm_uuid:any)=>{
  new callSDK.CallRestService().getVoicemailTranscript(Vm_uuid).then((response: any) => {
  
    if (response.statusCode === 200) {

      const voicemail = response?.result[0];

      try {
        const parsed = JSON.parse(voicemail?.transcripted_file);
        store.dispatch({
          type: Types.VOICE_MAIL_LIST,
          payload: {
            voicemailTrans: parsed?.vmsTranscript
          }
        }); 
      } catch (e) {
        console.error('Error parsing transcripted_file:', e);
        store.dispatch({
          type: Types.VOICE_MAIL_LIST,
          payload: {
            voicemailTrans: ""
          }
        }); 
      }
      
    }
    else if(response?.statusCode === 404){
      store.dispatch({
        type: Types.VOICE_MAIL_LIST,
        payload: {
          voicemailTrans: "data not found"
        }
      });
    }
  })
    .catch((err: any) => { 
      console.log("err>>>>>>>",err)
      });
}
export const groupingContacts = (contactData: workContact[]) => {

  let result: any = _(contactData)
    .groupBy(o => (o.caller_id && o.caller_id[0] ? o.caller_id[0].toUpperCase() : ""))
    .map((ContactList, group) => ({ group, ContactList }))
    .value();
  return result;
};

export const logInfo = (key: string, value: any) => {
  if (process.env.REACT_APP_ENV === 'development') {
    //console.log(key + " :-", value);
  }
};
export function detailStore(data: object) {

  storeParticularLog(data, false);
  listClkEvent();
  //max_Call_Window();

};
export function durationConvert(s: any) {
  return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
}

// for next list


export function statusVoiceMail(list: any) {
  let flag: string = list.ReadFlag;
  flag = (flag === "0") ? "1" : "0";
  let uid: any = list.Vm_uuid;
  new callSDK.CallRestService().updateVoiceLog(uid, flag).then((result: any) => {
    if (result.statusCode === 200) {
      // getVoiceMailList("", 0, 0);
    }
  })
    .catch((err: any) => { logInfo('statusVoiceMail err is', err); });
}

export const contactSearchData = (searchText: string) => {
  try {
    let contactReducer: contacts = store.getState().contactReducer || [];
    let companyContact: Array<workContact> = contactReducer.workContacts || [];
    if (searchText === '') { return groupingContacts(companyContact); }
    else {
      searchText = searchText.toLowerCase();
      let data: workContact[] = _.filter(companyContact, function (obj) {
        return ((obj.caller_id).toLowerCase().includes(searchText) ||
          ((obj.ext).toString()).includes(searchText));
      });
      return groupingContacts(data);
    }
  } catch (err: any) { return []; }
};

export const callActionChanges = (component: string) => {
  let updatedCallList: currentCallDetail = store.getState().updatedCallList || [];
  console.log("updatedCallList.rightSideWindowupdatedCallList.rightSideWindow>>>>>>>",updatedCallList.rightSideWindow);
  if (updatedCallList.minimizedWindow) {
    store.dispatch({
      type: Types.UPDATE_CALL_STATUS,
      payloads: {
        isWindowSlide: (updatedCallList.rightSideWindow === component && updatedCallList.centerWindow === "callWindow") ? false
          : updatedCallList.rightSideWindow === component && updatedCallList.centerWindow !== "callWindow" && updatedCallList.isCallFullScreen ? false : true,
        isCallFullScreen: updatedCallList.minimizedWindow ? true : false,
        rightSideWindow: (updatedCallList.rightSideWindow === component) ? (updatedCallList.isCallActive ? 'participantList' : 'dialpad') : component,
        minimizedWindow: true,
        isTranscriptionOnOff: true
      }
    });
  }
  else {
    store.dispatch({
      type: Types.UPDATDE_WINDOW_SLIDE,
      payloads: {
        isWindowSlide: (updatedCallList.rightSideWindow === component && updatedCallList.centerWindow === "callWindow") ? false
          : (updatedCallList.centerWindow !== "callWindow" && updatedCallList.callDetails.length !== 0) ? false
            : (updatedCallList.callPlusIcon && updatedCallList.rightSideWindow === component) ? false : true,
        isCallFullScreen: updatedCallList.minimizedWindow ? true : false,
        rightSideWindow: (updatedCallList.rightSideWindow === component) ? (updatedCallList.isCallActive ? 'participantList' : 'dialpad') : component,
        isTranscriptionOnOff: true
      }
    });
    if (updatedCallList.isTranscriptionOnOff && component !== 'dialpad')
      store.dispatch({
        type: Types.OPEN_PROFILE_VIEW,
        payloads: {
          isProfileView: false
        }
      });

  }
};

export const callWindowTranscription = (component: string) => {
  let updatedCallList: currentCallDetail = store.getState().updatedCallList || [];
  if (updatedCallList.minimizedWindow) {

    let isCallFullScreen: boolean = updatedCallList.callDetails.length > 1 ? true : false
    store.dispatch({
      type: Types.UPDATE_CALL_STATUS,
      payloads: {
        isWindowSlide: true,
        isCallFullScreen: isCallFullScreen,
        rightSideWindow: (updatedCallList.rightSideWindow === component) ? 'participantList' : component,
        // minimizedWindow: false,
        minimizedWindow: updatedCallList.callDetails.length > 1 ? true : false,
        isTranscriptionOnOff: true
      }
    });
  }
  else {
    store.dispatch({
      type: Types.UPDATDE_WINDOW_SLIDE,
      payloads: {
        isWindowSlide: (updatedCallList.rightSideWindow === component) ? false : true,
        isCallFullScreen: false,
        rightSideWindow: (updatedCallList.rightSideWindow === component) ? 'participantList' : component,
        isTranscriptionOnOff: true
      }
    });
  }
}

export const backToMainPage = () => {
  let updatedCallList: currentCallDetail = store.getState().updatedCallList || [];
  callActionChanges(updatedCallList.rightSideWindow);
};

export const toggleBtn = (updatedCallList: any) => {
  store.dispatch({
    type: Types.UPDATDE_WINDOW_SLIDE,
    payloads: {
      isWindowSlide: !updatedCallList.isWindowSlide,
      isCallFullScreen: !updatedCallList.isCallFullScreen,
      rightSideWindow: updatedCallList.rightSideWindow,
      isTranscriptionOnOff: updatedCallList.isTranscriptionOnOff
    }
  });
};

export const listClkEvent = () => {
  let callReducer: currentCallDetail = store.getState().updatedCallList || [];
  store.dispatch({
    type: Types.CALL_MINI_WINDOW,
    payloads: {
      isWindowSlide: (callReducer.callDetails.length > 0 || callReducer.callPlusIcon) ? false : true,
      minimizedWindow: (callReducer.callDetails.length > 0 && !callReducer.minimizedWindow) ? true : callReducer.minimizedWindow,
      centerWindow: (callReducer.leftSideWindow === 'callList') ? 'callDetail' : (callReducer.leftSideWindow === 'voiceMail') ? 'voiceDetail' : 'recordDetail',
      isCallFullScreen: true
    }
  });
};

export const max_Call_Window = () => {
  let callReducer: currentCallDetail = store.getState().updatedCallList || [];
  if (callReducer.callDetails.length > 0 && callReducer.isCallActive) {
    store.dispatch({
      type: Types.CALL_MINI_WINDOW,
      payloads: {
        isWindowSlide: false,
        minimizedWindow: true,
        centerWindow: (callReducer.leftSideWindow === 'callList') ? 'callDetail' : (callReducer.leftSideWindow === 'voiceMail') ? 'voiceDetail' : 'recordDetail',
        isCallFullScreen: false
      }
    });
  }
  store.dispatch({
    type: Types.UPDATE_RIGHT_WINDOOW,
    payloads: {
      rightSideWindow: 'dialpad'
    }
  });



};


export const getCurrentCallDetail = () => {
  let currentCallInfo: calldetail[] = store.getState().updatedCallList.callDetails || [];
  let callInfo = currentCallInfo.find((e: calldetail) => (e.isCurrent === true));

  return callInfo || {};

};

export const voiceMaillInnertopDate = (stamp: any) => {
  let day: any = new Date(stamp);
  let min = day.getMinutes().toString().padStart(2, "0");
  let Bdate = day.getHours() + ":" + min;

  let time: any = Bdate.split(" ");
  let ampm: any;

  let [hours, minutes] = time[0].split(":");
  ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  time = hours + ":" + minutes + " " + ampm;

  let month: any = parseInt(day.getMonth()) + 1;
  let date =
    day.getDate().toString().length > 1 ? day.getDate() : "0" + day.getDate();
  month = month.toString().length > 1 ? month : "0" + month;
  let year = day.getFullYear();
  let newdate = date + "/" + month + "/" + year;

  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];

  var curDate = new Date();
  var Cdate =
    curDate.getDate() +
    "-" +
    (curDate.getMonth() + 1) +
    "-" +
    curDate.getFullYear();
  var Ydate =
    curDate.getDate() -
    1 +
    "-" +
    (curDate.getMonth() + 1) +
    "-" +
    curDate.getFullYear();
  var Tdate =
    day.getDate() + "-" + (day.getMonth() + 1) + "-" + day.getFullYear();
  var group = Tdate;
  if (Cdate === Tdate) group = "Today";
  else if (Ydate === Tdate) group = "Yesterday";

  return days[day.getDay()] + " " + newdate + " " + time + " " + group;
};

export const boundFrame = (callType: string) => {
  if (callType === "OUTBOUND") return "Outgoing";
  else if (callType === "INBOUND") return "Incoming";
  return "Missed";
};
export const getContactUsingExt: any = (data: conferenceDetailUserInfo) => {

  let loggedUserDetails: any = store.getState().loginReducer.userdetails || [];
  let ext: string = loggedUserDetails.ext;
  let extension = data.entity.split("@")[0];
  if (extension === ext.toString()) { return loggedUserDetails; }
  else {
    let contactReducer: contacts = store.getState().contactReducer || [];
    let companyContact: Array<workContact> = contactReducer.workContacts || [];
    let contact = companyContact.find((contac: any) => (contac.ext.toString() === extension));

    if (contact === undefined) { return { caller_id: 'Unknow Caller', ImageURL: '', ext: '' }; }
    return contact;
  }
};

export const checkCurrentUserHost = (host_entity: string) => {
  let loggedUserDetails: any = store.getState().loginReducer.userdetails || [];
  let ext: string = loggedUserDetails.ext;
  if (host_entity.split("@")[0] === ext.toString()) { return true; }
  else { return false; }
};

export const quickChat = (ext: string, history: any) => {
  let contactdetail = filterContact(ext);
  ChatService.openChatWindow(contactdetail, history);
  ChatService.editDraft("");
};

export const userStatusColor = (status: string, size: string) => {
  if (status === 'Available')
    return size === 'big' ? 'stsDotmd green' : size === 'xsmall' ? 'stsDotsmxs green' : 'stsDotsm green';
  else if (status === 'Appear Busy' || status === "In a Call")
    return size === 'big' ? 'stsDotmd pink' : size === 'xsmall' ? 'stsDotsmxs pink' : 'stsDotsm pink';
  else if (status === 'Do not disturb')
    return size === 'big' ? 'stsDotmd red' : size === 'xsmall' ? 'stsDotsmxs red' : 'stsDotsm red';
  else if (status === 'Do not disturb')
    return size === 'big' ? 'stsDotmd red' : size === 'xsmall' ? 'stsDotsmxs red' : 'stsDotsm red';
  else if (status === 'Appear Away')
    return size === 'big' ? 'stsDotmd orange' : size === 'xsmall' ? 'stsDotsmxs orange' : 'stsDotsm orange';
  else return size === 'big' ? 'stsDotmd grey' : size === 'xsmall' ? 'stsDotsmxs grey' : 'stsDotsm grey';
};

export const searchHighlight = (data: any, search: any) => {
  if (search === "") { return; }
  else {
    let message = {
      firstMsg: "",
      middleMsg: "",
      lastMsg: "",
      key: ''
    };
    let tempSearch = search;
    let caller_id = (data?.caller_id) ? (data?.caller_id) : (data.team_name);
    let time = data?.time;
    let searchIndexName = caller_id?.toLowerCase().indexOf(tempSearch.toLowerCase());
    let searchIndexDate = data?.time?.toLowerCase().indexOf(tempSearch.toLowerCase());
    if (search !== undefined) {
      if (searchIndexName !== -1 && caller_id) {
        message.firstMsg = caller_id.substring(0, searchIndexName);
        message.middleMsg = caller_id.substring(searchIndexName, searchIndexName + search.length);
        message.lastMsg = caller_id.substring(searchIndexName + search.length);
        message.key = 'name';
      }
      else if (searchIndexDate !== -1 && time !== undefined) {
        message.firstMsg = time.substring(0, searchIndexDate);
        message.middleMsg = (time.substring(searchIndexDate, searchIndexDate + search.length));
        message.lastMsg = time.substring(searchIndexDate + search.length);
        message.key = 'date';
      }
    }
    return message;
  }
};
export const filterContact = (ext: any) => {

  let loggedUserDetails: any = store.getState().loginReducer.userdetails || [];
  let contactReducer: contacts = store.getState().contactReducer || [];
  let companyContact: Array<workContact> = contactReducer.workContacts || [];
  if (ext.toString().length > 3) {
    let contactdetail = _.find(companyContact, function (user: any) {
      if (user.direct_no) {
        let directNumber = (user.direct_no).split(",");
        return _.some(directNumber, function (right) {
          return ext.toString() === (right.toString()).trim();
        });
      }
    }); return contactdetail
  }
  else {
    if (ext.toString() === loggedUserDetails.ext.toString()) { return loggedUserDetails; }
    else {
      let contactdetail = companyContact.find(obj => (obj.ext).toString() === ext);
      return contactdetail;
    }
  }
};

export const makeFavourite = (isFav: any, selectedContact: any) => {
  let loggedUser: any = store.getState().loginReducer.userdetails || [];
  const cookieData = JSON.parse(loggedUser.sip_login_id);
  const socketService = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
  let chatDetails = {
    chatId: generateChatID(loggedUser.sip_login_id, selectedContact?.sip_login_id.toString()),
    toSipId: selectedContact?.sip_login_id?.toString(),
    settingsKey: "isFavourite",
    status: isFav,
    type: selectedContact?.sip_login_id ? 1 : 2,
    phoneNumber: selectedContact?.ext,
    fromCall: true
  };
  socketService.updateRecentChatSettings(chatDetails)

};

export const makeMute = (data: any, detail: any) => {

};

export const filterMeetingContact = (ext: any) => {
  let loggedUserDetails: any = store.getState().loginReducer.userdetails || [];
  let contactReducer: contacts = store.getState().contactReducer || [];
  let companyContact: Array<workContact> = contactReducer.workContacts || [];

  if (ext?.toString() === loggedUserDetails.ext?.toString()) { return loggedUserDetails; }
  else {
    let contactdetail = companyContact.find(obj => (obj.ext).toString() === ext?.toString());
    return contactdetail;
  }
};
export const DataURIToBlob = (URL: any) => {
  const splitDataURI = URL.split(',');
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++)
    ia[i] = byteString.charCodeAt(i);
  console.log("ia[iii]", ia);

  return new Blob([ia], { type: mimeString });
};

export const check_Ext_valid = (inputtxt: any) => {
  var letters = /^[A-Za-z]+$/;
  if (inputtxt.match(letters)) { return false; }
  else { return true; }
};

export const asrSearchLanguage = (languages: any, searchText: string) => {
  searchText = searchText.toLowerCase();
  return _.filter(languages, function (obj) {
    return ((obj.languageName).toLowerCase().includes(searchText));
  });
};

export const createHtmlPage = () => {
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];
  //'MOM' -- 'updateLanguage' -- 'Transcription'

  let editautomatedmins: any = [];

  editautomatedmins = (closeCaption.shareFrom === 'MOM') ?
    closeCaption.editautomatedmins : (closeCaption.asrCallingFrom === 'callList') ?
      closeCaption.transcripts : closeCaption.voiceTranscript;

  let preHtml = "<html>" +
    "<head><meta charset='utf-8'><title>Meeting Summary</title></head><body>" +
    '<table style="width:98%;">' +
    "<tr><td style='font-size: 12px; color: #848E9D; width:100%; text-align:center;'>Meeting Summary</td></tr>" +
    "<tr><td style='width:100%; text-align:center;color: #374151;font-size: 16px; font-weight: bold;'>" +
    "Conference Call</td ></tr > " +
    "<tr><td style='width:100%; text-align:center;color: #848E9D; font-size: 10px;'>9 Aug 2021 - 9:21 PM</td></tr>";
  let postHtml = "</table></div></body></html>";
  let bodyText: any = '';
  editautomatedmins.forEach((element: any) => {
    bodyText +=
      '<tr><td style="line-height: 24px;padding:6px 0; font-size:13px;">';

    if (closeCaption.asrCallingFrom === 'callList') {
      bodyText += '<b style="color:#439CF3;line-height:37px; text-transform: capitalize;">' +
        element.speakerName + '</b>';
    }
    bodyText += '<br/>';
    if (closeCaption.shareFrom === "updateLanguage") {
      if (closeCaption.asrCallingFrom === 'callList') {
        bodyText += element.convertedText ? element.convertedText.replace(/\s/g, '&nbsp;') : '';
      }
      else {
        bodyText += element[closeCaption.updatedLanguages.transcription_code].replace(/\s/g, '&nbsp;');
      }
    }
    else { bodyText += element.text.replace(/\s/g, '&nbsp;'); }

    bodyText += '</td></tr>';
  });
  return preHtml + bodyText + postHtml;
};

export const PDfSharenDownload = async (isDownload: boolean, srcTag?: any) => {
  toastInformation('Generating PDF file. Please wait', 'alert');
  let downloadUrl;
  let { quilDiv } = store.getState().closeCaption || {};
  var source: any;
  let bodyText = '';
  let text = (srcTag ? srcTag : quilDiv)
  bodyText +=
    '<div style=" margin-left: 40px;font-size: 11px;color: #4B5563;line-height: 17px;position: relative;">'
    + text + '</div>';
  source = bodyText;
  var doc = new jsPDF({
    orientation: 'portrait',
    unit: 'pt'
  });
  const result = await doc.html(source, {
    margin: [40, 100, 100, 60],
    callback: async function (doc: any) {
      let pdfurl: string = doc.output("dataurlstring");
      //let basepdfurl:any =  pdfurl.replace('data:application/pdf;filename=generated.pdf;base64,', '')+  encodeURIComponent(source) ;
      downloadUrl = await DataURIToBlob(pdfurl);
      if (isDownload) {
        let filename = 'conference.pdf';
        var downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        downloadLink.href = pdfurl;
        downloadLink.download = filename;
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
      return downloadUrl;
    }
  });
  return result;


}
export const wordSharenDownnload = async (isDownload: boolean, srcTag?: any) => {
  let { quilDiv } = store.getState().closeCaption || {};
  var header: any = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
    "xmlns='http://www.w3.org/TR/REC-html40'>" +
    "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
  var footer: any = "</body></html>";
  var sourceHTML: any = '';
  sourceHTML = header + (srcTag ? srcTag : quilDiv) + footer;
  var url = 'data:application/msword;charset=utf-8,' + encodeURIComponent(sourceHTML);
  let blob = await DataURIToBlob(url);
  if (isDownload) {
    let filename = 'conference.doc';
    var downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.href = url;
    downloadLink.download = filename;
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  return blob;
};

export const wordFormatVideo = async (isDownload: boolean, srcTag?: any) => {
  let { quilDiv } = store.getState().closeCaption || {};
  var header: any = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
    "xmlns='http://www.w3.org/TR/REC-html40'>" +
    "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
  var footer: any = "</body></html>";
  var sourceHTML: any = '';
  sourceHTML = header + (srcTag ? srcTag : quilDiv) + footer;
  var url = 'data:application/msword;charset=utf-8,' + encodeURIComponent(sourceHTML);
  let blob = await DataURIToBlob(url);
  if (isDownload) {
    let filename = 'conference.doc';
    var downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.href = url;
    downloadLink.download = filename;
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  return blob;
};

export const noUrlData = () => {
  toastInformation('No content Audio Source', "failure");
};

export const volumeDecrease = (volume: number) => {
  try {
    let audio: any = document.getElementById('remoteVideo');
    if (audio) {
      audio.volume = volume;
    }
  } catch (error) {
    logInfo("volumeDecrease error ", error);
  }
};

export const transcription_On_Off = (apiTranscript: any, asrCallingFrom?: string) => {
  let updatedCallList: currentCallDetail = store.getState().updatedCallList || [];
  let transcriptData: any = [];
  if (apiTranscript?.transcript && apiTranscript?.transcript !== "") {

    if (updatedCallList.rightSideWindow === 'transcript') {


      let en = apiTranscript?.transcript?.split("\n");
      let es = apiTranscript?.translation[0]?.text?.split("\n");
      let fr = apiTranscript?.translation[1]?.text?.split("\n");
      let pt = apiTranscript?.translation[2]?.text?.split("\n");
      let ja = apiTranscript?.translation[3]?.text?.split("\n");
      let ko = apiTranscript?.translation[4]?.text?.split("\n");

      for (let i = 0; i < en.length; i++) {

        let transcript = {
          lang: 'en',
          text: en[i],
          es: es[i],
          fr: fr[i],
          pt: pt[i],
          ja: ja[i],
          ko: ko[i]
        };
        transcriptData.push(transcript);
      }
    }
    store.dispatch({
      type: Types.VOICE_MAIL_TRANSCRIPTS,
      payload: {
        transcripts: transcriptData
      }
    });
  }

  // store.dispatch({
  //   type: Types.ASR_CALLING_FROM,
  //   payload: {
  //     asrCallingFrom: asrCallingFrom
  //   }
  // });
  //  callActionChanges('transcript');

  // let transcriptData:any = [
  //   {
  //     lang: "en", convertedText:'',
  //     time: '00:00:00,100 --> 00:00:05,290', text: 'THIS is different tundefined',
  //     es:'esta es una',
  //     fr: 'c est différent',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:05,300 --> 00:00:09,290', text: 'page of the simple English Wikipedia Wikipedia places where people',
  //     es:'página diferente de la wikipedia en inglés simple. lugares de wikipedia donde las personas',
  //     fr: 'page des endroits simples de wikipédia en anglais où les gens',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en", 
  // convertedText: '',
  //     time: '00:00:09,300 --> 00:00:15,390', text: 'work together to write Encyclopaedia in simple',
  //     es:'trabajan juntas para escribir una enciclopedia en',
  //     fr: 'travaillent ensemble pour écrire une encyclopédie en mots et grammaire anglais simples ici.',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:15,400 --> 00:00:17,689', text: 'English words and grammar here.',
  //     es:'palabras y gramática simples en inglés.',
  //     fr: 'le wikipedia anglais simple est pour tout le monde, y compris',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:17,700 --> 00:00:23,189', text: 'The simple English Wikipedia is for everyone that includes',
  //     es:'la wikipedia en inglés simple es para todos los que incluyen',
  //     fr: 'les enfants et les adultes apprenaient l anglais la',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:23,200 --> 00:00:29,889', text: 'children and adults were learning English there are 230404',
  //     es:'niños y adultos estaban aprendiendo inglés. la',
  //     fr: 'licence creative commons attribution-sharealike',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:29,900 --> 00:00:35,090', text: 'articles on simple English Wikipedia free',
  //     es:'licencia creative commons de atribución-compartir-igual',
  //     fr: 'et les adultes apprenaient l anglais la',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",speakerName:'balaji',convertedText:'',
  //     time: '00:00:35,100 --> 00:00:40,190', text: 'to use they ve all been published under the',
  //     es:'niños y adultos estaban aprendiendo',
  //     fr: 'et les adultes apprenaient l anglais la',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:40,200 --> 00:00:45,690', text: 'creative commons attribution-sharealike licence',
  //     es:'página diferente de la wikipedia en inglés simple. lugares de wikipedia donde las personas',
  //     fr: 'page des endroits simples de wikipédia en anglais où les gens',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:45,700 --> 00:00:46,890', text: '3.2',
  //     es:'3.2',
  //     fr: '3.2',
  //     pt: '3.2',
  //     ja: '3.2',
  //     ko: '3.2'
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:46,900 --> 00:00:49,790', text: 'and free documentation licence.',
  //     es:'y la licencia de documentación gratuita.',
  //     fr: 'et la licence de documentation gratuite.',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:49,800 --> 00:00:54,890', text: 'You can help you can make you may change these',
  //     es:'usted puede ayudar puede hacer que pueda cambiar estos### ###páginas y crear nuevas páginas.',
  //     fr: 'vous pouvez vous aider vous pouvez faire vous pouvez les modifier## ##pages et créerde nouvelles pages',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   },
  //   {
  //     lang: "en",  convertedText:'',
  //     time: '00:00:54,900 --> 00:00:56,890', text: 'pages and make new pages.',
  //     es:'niños y adultos estaban aprendiendo',
  //     fr: 'et les adultes apprenaient l anglais la',
  //     pt: '',
  //     ja: '',
  //     ko: ''
  //   }
  // ];

  // let transcriptData: any = [];
  // store.dispatch({
  //   type: Types.VOICE_MAIL_TRANSCRIPTS,
  //   payload: {
  //     transcripts: transcriptData
  //   }
  // });




  else {
    store.dispatch({
      type: Types.VOICE_MAIL_TRANSCRIPTS,
      payload: {
        transcripts: []
      }
    });

  }
};


export const languageChange = () => {
  let caption: closeCaptionmeetingState = store.getState().closeCaption || [];
  var obj: any = {};
  caption?.voiceTranscript?.map((recent: any) => {
    let min = (((recent?.time?.split('-->'))[0]).split(",")[0]);
    let data = {
      second: min,
      text: recent.text,
      es: recent.es,
      fr: recent.fr,
      pt: recent.pt,
      ja: recent.ja,
      ko: recent.ko
    };
    obj[min] = data;
  });


  urlTranscription(obj, '', '');

};

export const dwldCallTranscript=()=>{
  let {audioTranscript}=store.getState().closeCaption;
  let bodyText: any = "";
  audioTranscript.forEach((element: any) => {
    bodyText += '<div style="width: 100%;"><span style="font-size: 10px;white-space: nowrap;">' + element.speakerName + '</span>' + ':' + '<span style="display: inline-block;width: 450px;font-size: 10px;color: #4B5563;">' + element.finalText + '</span></div></br>';
  });
  let downloadUrl: any;
  var doc = new jsPDF({
    orientation: 'portrait',
    unit: 'pt'
  });
  const result = doc.html(bodyText, {
    margin: [80, 100, 100, 100],
    callback: async function (doc: any) {
      let pdfurl: string = doc.output("dataurlstring");

      downloadUrl = DataURIToBlob(pdfurl)

      let filename = `Call.pdf`;

        var downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        downloadLink.href = pdfurl;
        downloadLink.download = filename;
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
      })
  bodyText = "";
}

// export const languageUpdateAnother = (lanChar:string) => {

//   let closeCaption:closeCaptionmeetingState = store.getState().closeCaption || [];
//   let transcript: any = closeCaption.voiceTranscript || [];
//   let finalData: any = [];
//   transcript.map((recent: any) => {
//     let data = { 'convertedText': recent[lanChar],'text':recent['text']};
//     finalData.push(data);
//   });
//   store.dispatch({
//     type: Types.TRANSCRIPTS_LIST,
//     payload: { transcripts: finalData }
//   });
// };

export const storeTranslatedLanguage = (updatedLanguage: any) => {
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];
  if (closeCaption.asrCallingFrom === 'callList') {
    let { transcripts } = closeCaption;
    if (updatedLanguage.transcripts.length !== 1) {
      let remove_OldData = transcripts.splice(updatedLanguage.transcripts.length, transcripts.length);
      let finalData = [...updatedLanguage.transcripts, ...remove_OldData];

      store.dispatch({
        type: Types.TRANSCRIPTS_LIST,
        payload: { transcripts: finalData }
      });

    }
    else {
      let index = transcripts.findIndex((elem: any) => (elem.guid === updatedLanguage.transcripts[0].guid));
      if (index !== -1) {
        transcripts[index].convertedText = updatedLanguage.transcripts[0].convertedText;
        transcripts[index].covertedlang = updatedLanguage.transcripts[0].covertedlang;
      }
      else { transcripts.push(updatedLanguage.transcripts[0]); }

      store.dispatch({
        type: Types.TRANSCRIPTS_LIST,
        payload: { transcripts: transcripts }
      });

    }
  }
  else {
    store.dispatch({
      type: Types.VOICE_MAIL_TRANSCRIPTS,
      payload: { transcripts: updatedLanguage.transcripts }
    });
  }

};

export const MOM_On_Off = (recordData: any, component: string) => {
  let updatedCallList: currentCallDetail = store.getState().updatedCallList || [];
  // let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];

  if (updatedCallList.rightSideWindow === component) {
    filterASRKey()
  }

  // if (recordData.txt && recordData.txt !== "") {
  //   if (updatedCallList.rightSideWindow !== component) {
  //     const { keywords } = store.getState().closeCaption;
  //     let data = recordData.txt.split("\n");
  //     data.forEach((element: any) => {
  //       keywords.some(function(item: any) {
  //         if (element.includes(item)) {
  //           let mom = {
  //             lang: "en",
  //             speakerName: recordData.caller_id,
  //             text: element
  //           };
  //           storeMomData(mom);
  //           return true;
  //         }
  //       });
  //     });
  //   }
  // }

};

export const filterASRKey = () => {
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];

  const { keywords, transAPI } = closeCaption;
  let finalData: any = [];
  transAPI.translation.forEach((element: any) => {
    keywords.some(function (item: any) {
      if (element.text.toLowerCase().includes(item.toLowerCase())) {
        let mom = {
          lang: element.lang,
          text: element.text
        };
        finalData.push(mom);
        return true;
      }
    });
  });
  store.dispatch({
    type: Types.AUTOMATED_MINS_LIST_EDIT,
    payload: {
      editautomatedmins: finalData,
      isTranscriptLoading: false
    }
  });

}

export const audioLanguageChange = (lanChar: string, guid: string) => {
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];

  if (closeCaption.localStreaming === 'stopped' && closeCaption.remoteStreaming === 'stopped') {
    initializeRecognition(lanChar, guid + "_loc");
    setTimeout(function () {
      initializeRecognition(lanChar, guid + "_rem");
    }, 1000);

    store.dispatch({
      type: Types.ASR_STATUS,
      payload: {
        localStreaming: 'started',
        remoteStreaming: 'started',
        guid: guid
      }
    });
  }
  else {
    let localStatus: string = 'started', remoteStatus: string = 'started';
    if (closeCaption.localStreaming === 'started' || closeCaption.localStreaming === 'need_to_start') {
      stopRecognition(guid + "_loc"); localStatus = 'need_to_start';
    }
    else { initializeRecognition(lanChar, guid + "_loc"); }

    if (closeCaption.remoteStreaming === 'started' || closeCaption.remoteStreaming === 'need_to_start') {
      stopRecognition(guid + "_rem"); remoteStatus = 'need_to_start';
    }
    else { initializeRecognition(lanChar, guid + "_rem"); }
    store.dispatch({
      type: Types.ASR_STATUS,
      payload: {
        localStreaming: localStatus,
        remoteStreaming: remoteStatus,
        guid: guid
      }
    });
  }
};
export const outputLanguageChange = (lanChar: string, guid: string) => {
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];
  if (closeCaption.remoteStreaming === 'stopped') {
    initializeRecognition(lanChar, guid + "_rem");
  }
};

export const SelectDatePicker = () => {
  var options: any = [];
  var day = "";
  let today = moment().format('YYYY-MM-DD');
  let tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
  for (var i = 0; i < 10; i++) {
    var dte = new Date();
    dte.setDate(dte.getDate() + i);

    if (today === moment(dte).format('YYYY-MM-DD')) {
      day = "(Today)";
    } else if (tomorrow === moment(dte).format('YYYY-MM-DD')) {
      day = "(Tomorrow)";
    } else {
      day = " ";
    }

    var formattedDate = moment(dte).format('ddd, MMM DD, YYYY') + " " + day;
    options.push(formattedDate);
  }
  return options;
};

export const newTaskWindow = (selectkey: string) => {
  store.dispatch({
    type: Types.TRANSCRIPTS_NEWTASK,
    payload: { tasklist: selectkey }
  });
};

export const deleteTask = (guid: string) => {
  let taskList = store.getState().closeCaption.tasklist || [];
  let index = _.findIndex(taskList, { guid: guid });
  if (index !== -1) { taskList.splice(index, 1); }
};

export const replaceTaskGuid = (guid: string, repalceId: string, contact: any) => {
  let taskList = store.getState().closeCaption.tasklist || [];
  let index = _.findIndex(taskList, { guid: guid });
  if (index !== -1) {
    taskList[index].guid = repalceId;
    taskList[index].contact = contact;
  }
};

export const removeTaskList = (guid: string) => {
  let taskList = store.getState().closeCaption.tasklist || [];
  let index = _.findIndex(taskList, { guid: guid });
  if (index !== -1) { taskList.splice(index, 1); }
};

export const filterFavouriteCalls = (neededArray: Array<any>) => {
  let filteredList = [];
  filteredList = _.filter(neededArray,
    ((item: any) => { return item.fav_status === 1 || item.is_favourite === 1; }));
  return _.uniqBy(filteredList, 'ext');
};

export const selectList = (list: Array<any>, id: string) => {
  let isPresent = list?.indexOf(id) > -1 ? true : false;
  if (!isPresent) {
    list?.push(id);
    return list;
  }
  else {
    let index = list?.indexOf(id);
    if (index !== -1) { list?.splice(index, 1); }
    return list;
  }
};
export const handlingKeyMovement = (e?: any) => {
  const event = window.event ? window.event : e;
  let { particularLog, logs } = store.getState().callReducer || {};
  let { leftSideWindow } = store.getState().updatedCallList || {};
  let position: number = 0;
  let uniqueId: string;
  uniqueId = leftSideWindow === 'callList' ? 'ext' : (leftSideWindow === 'voiceMail' ? 'Vm_uuid' : 'uuid')
  position = _.findIndex(logs, function (o: any) {
    return (o[uniqueId]).toString() === particularLog[uniqueId].toString();
  });
  if (event.keyCode === 40 && (position < logs.length - 1)) return position + 1;
  else if (event.keyCode === 38 && position > 0) return position - 1;
};

export const getlanguageName = (list: any, lanCode: string) => {
  return _.find(list, { languageCode: lanCode });
};

export const secondsToTime = (secs: number) => {
  var hours = Math.floor(secs / (60 * 60));
  var divisor_for_minutes = secs % (60 * 60);
  var minutes = Math.floor(divisor_for_minutes / 60);

  var divisor_for_seconds = divisor_for_minutes % 60;
  var seconds = Math.ceil(divisor_for_seconds);
  var obj = {
    "h": (hours.toString().length === 1) ? '0' + hours : seconds,
    "m": (minutes.toString().length === 1) ? '0' + minutes : minutes,
    "s": (seconds.toString().length === 1) ? '0' + seconds : seconds
  };
  return obj;
};

export const downloadURL = (Rec: string) => {
  try {
    let fileName: any = Rec.substring(Rec.lastIndexOf('/') + 1);
    var xhr = new XMLHttpRequest();
    xhr.open("GET", Rec, true);
    xhr.responseType = "blob";

    xhr.onload = function () {
      var urlCreator = window.URL || window.webkitURL;
      var audioURL = urlCreator.createObjectURL(this.response);
      var tag = document.createElement("a");
      tag.href = audioURL;
      tag.download = fileName;
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
    };
    xhr.send();
    toastInformation("Downloaded successfuly", "success");
  }
  catch (error) {
    logInfo('Downloading error', error);
    toastInformation("Downloading failed", "failure");
  }


};

export const editTaskCalling = (contactDetails: any) => {
  contactService.openContactWindow(contactDetails);
};

export const currentTimer = () => {
  let day: any = new Date();
  let min = day.getMinutes().toString().padStart(2, "0");
  let Bdate = day.getHours() + ":" + min;
  let time: any = Bdate.split(" ");
  let ampm;
  let [hours, minutes] = time[0].split(":");
  ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  let currentTime = {
    time: hours + ":" + minutes,
    amPm: ampm,
    date: day.getDate(),
    day: daysInWord[day.getDay()],
    month: monthInWord[day.getMonth()],
    year: day.getFullYear()

  };
  return currentTime;
};
export const initiateAPICall = () => {
  let { leftSideWindow } = store.getState().updatedCallList;
  let { logsInput } = store.getState().callReducer;
  let { filter, search, offset } = logsInput;
  switch (leftSideWindow) {
    case 'voiceMail':
      getVoiceMailLogs(offset, search);
      break;
    case 'recordList':
      getRecordingLogs(offset, search);
      break;
    default:
      getCallLogsCDR(offset, filter, search);
      break;
  }
};


export const searchHandler = (needTosearchArray: Array<any>, searchedText: string) => {
  let searchText = searchedText?.toLowerCase();
  return _.filter(needTosearchArray, function (data: any) {
    let caller_id = data.caller_id || "";
    let team_name = data.team_name || '';
    let ext = data.ext || "";
    let date = data?.time || '';
    return (((caller_id).toLowerCase()).includes(searchText)
      || (ext.toString()).includes(searchText)
      || (team_name.toLowerCase()).includes(searchText)
      || (date.toLowerCase()).includes(searchText)
    );
  });
};

export const secondsToHMSConverter = (time: number) => {
  // Hours, minutes and seconds
  let hrs = ~~(time / 3600);
  let mins = ~~((time % 3600) / 60);
  let secs = ~~time % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  if (hrs > 0) {
    return hrs + ' h ' + (mins > 0 ? (mins + ' min') : '');
  }
  else if (mins > 0) {
    return mins + ' min ' + (secs > 0 ? (secs + ' sec') : '');
  }
  return secs + ' sec';

};

export const avatarCreater = (data: any) => {
  let contact: any = data;
  let tileSize: string = '';
  let teamMembersName: any = [];

  if (contact.team_id !== '' || contact.team_id !== undefined || contact.team_members == null) {
    let teamMemberarrayforImage: any;
    if (contact?.team_id) {

      teamMemberarrayforImage = contact.team_id && contact.team_members &&
        contact?.team_members?.replace(" ", "").split(',');
      teamMemberarrayforImage?.map((list: any) => {
        let c_details = getcontactDetail(list);
        teamMembersName.push(c_details?.caller_id);
      });

      if (teamMembersName.length > 3) tileSize = 'four';
      else if (teamMembersName.length === 3) tileSize = 'three';
      else if (teamMembersName.length === 2) tileSize = 'two';

    }
  }

  return { 'size': tileSize, 'teamMembers': teamMembersName.length > 0 ? teamMembersName : [] };

};

export const altRecTimer = (timer: string) => {
  let alter: any = timer?.split(':');
  return alter && (alter[0] === '00' ? (alter[1] + ':' + alter[2]) : timer)
};

export const shareFileWithMsg = (toIds: Array<any>, groupFile: any) => {
  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  toIds.map((mem: any) => {
    let { userdetails }: LoginState = store.getState().loginReducer;
    let { allContacs }: contacts = store.getState().contactReducer;
    let finalReceiver: any;
    let member: string = mem.toString();

    if (member && member.includes("con")) {
      finalReceiver = allContacs.find((List: any) => List.team_id && List.team_id.toString() === member.slice(3));
      return socketChat.sendFileToGroup(groupFile, finalReceiver, true);
    }
    else {
      if (userdetails?.sip_login_id.toString() === member) {
        finalReceiver = userdetails.caller_id;
        return logInfo('finalReceiver user', finalReceiver);
      }
      finalReceiver = allContacs?.find((List: any) => List?.sip_login_id && List?.sip_login_id.toString() === member);

      return socketChat.newMessageFileAttach(groupFile.fileName, groupFile.fileType, groupFile.filesize, groupFile.filePath, finalReceiver, true, groupFile.text);
    }
  });
}

export const noTranscript = () => {
  store.dispatch({
    type: Types.VOICE_MAIL_TRANSCRIPTS,
    payload: {
      transcripts: []
    }
  });
  store.dispatch({
    type: Types.AUTOMATED_MINS_LIST_EDIT,
    payload: {
      editautomatedmins: [],
      isTranscriptLoading: false
    }
  });
  store.dispatch({
    type: Types.TRANS_RESULT,
    payload: {
      transAPI: []
    }
  });
}

export const gotoChat = (personDetail: any, history: any, list: any) => {
  let { userdetails }: LoginState = store.getState().loginReducer;
  const socketservice = new SocketChatService(userdetails.sip_login_id, userdetails.domain_id);
  if (personDetail?.sip_login_id) {
    let chatDetail = { chatId: generateChatID(userdetails.sip_login_id.toString(), personDetail.sip_login_id.toString()) };
    socketservice.openChatWindow(personDetail, history, chatDetail, 'notify');
    setTimeout(() => {
      socketservice.saveChatHighlight(true, list);
    }, 500)
  }
  else if (personDetail?.team_id) {
    let chatDetail = { chatId: generateChatID(userInfo().fromID, personDetail?.sip_login_id ? personDetail?.sip_login_id.toString() : personDetail?.team_id.toString()) };
    ChatService.openChatWindow(personDetail, history, chatDetail)
    setTimeout(() => {
      socketservice.saveChatHighlight(true, list);
    }, 500)
  }
}
export const goCalltoChat = (personDetail: any, history: any, list: any) => {
  let { userdetails }: LoginState = store.getState().loginReducer;
  const socketservice = new SocketChatService(userdetails.sip_login_id, userdetails.domain_id);
  if (personDetail?.sip_login_id) {
    let chatDetail = { chatId: generateChatID(userdetails.sip_login_id.toString(), personDetail.sip_login_id.toString()) };
    socketservice.openChatWindow(personDetail, history, chatDetail, 'contactpage');
    socketservice.saveChatHighlight(false, {});
  }
  else if (personDetail?.team_id) {
    let chatDetail = { chatId: generateChatID(userInfo().fromID, personDetail?.sip_login_id ? personDetail?.sip_login_id.toString() : personDetail?.team_id.toString()) };
    ChatService.openChatWindow(personDetail, history, chatDetail)
    socketservice.saveChatHighlight(false, {});
  }
}

export const setIcon = (format: any) => {
  let icon = '';
  switch (format) {
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      icon = wordicon;
      break;
    case "application/vnd.ms-powerpoint":
      icon = powerpointicon;
      break;
    case "application/pdf":
    case 'application/msword':
      icon = pdficon;
      break;
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      icon = excelicon;
      break;
    case "image/png":
    case "image/jpeg":
      icon = grid_image;
      break;
    case "audio/mpeg":
      icon = grid_music;
      break;
    default:
      icon = grid_zip;
      break;
  }
  return icon;

}


export const searchTeamUsers = (needTosearchArray: any, searchedText: string, isSplit: boolean) => {
  let findText = searchedText?.toLowerCase();
  let { GroupDetails, PSTNDetails, IndividualDetails } = needTosearchArray.groupCallInfo || {};
  let arrData: any = {
    groupRender: [],
    IndividualRender: [],
    PSTNRender: [],
    RenderJoined: [],
    RenderInvited: []
  };
  if (needTosearchArray.isGroupCall) {

    if (isSplit) {
      Object.keys(GroupDetails)?.map((gKey: any) => {
        let newKey: any = GroupDetails[gKey];
        let storeArray: any = [];
        Object.keys(newKey)?.map((member: any) => {
          if (((newKey[member].caller_id?.toLowerCase().includes(findText)) || (member?.toLowerCase().includes(findText)))
            && (newKey[member].callStatus !== 'Disconnected') && (newKey[member].callStatus !== 'Removed')) {
            Object.assign(storeArray, { [member]: newKey[member] });
          }
        })
        if (storeArray.length > 0) { Object.assign(arrData.groupRender, { [gKey]: storeArray }); }

      });

      Object.keys(IndividualDetails)?.map((gKey: any) => {
        if ((((IndividualDetails[gKey].caller_id).toString()?.toLowerCase().includes(findText)) || ((IndividualDetails[gKey].ext).toString().toLowerCase().includes(findText)))
          && (IndividualDetails[gKey].callStatus !== 'Disconnected') && (IndividualDetails[gKey].callStatus !== 'Removed')) {
          Object.assign(arrData.IndividualRender, { [gKey]: IndividualDetails[gKey] });
        }
      });

      Object.keys(PSTNDetails)?.map((gKey: any) => {
        if ((gKey?.toLowerCase().includes(findText)) && (gKey.callStatus !== 'Disconnected') && (gKey.callStatus !== 'Removed')) {
          Object.assign(arrData.PSTNRender, { [gKey]: PSTNDetails[gKey] });
        }
      });

      return arrData;
    }
    else {
      return diffGroupUsers(needTosearchArray, findText);
    }
  }
  else {
    let caller_id = needTosearchArray.contact?.caller_id || "";
    let team_name = needTosearchArray.contact?.team_name || '';
    let ext = needTosearchArray.contact?.ext || "";
    if (((caller_id).toLowerCase()).includes(findText)
      || (ext.toString()).includes(findText)
      || (team_name.toLowerCase()).includes(findText)) {
      return [needTosearchArray];
    }
    else { return []; }
  }
}

export const diffGroupUsers = (activeCall: any, findText: string) => {
  let { GroupDetails, PSTNDetails, IndividualDetails } = activeCall.groupCallInfo || {};
  let { userdetails }: LoginState = store.getState().loginReducer;
  let directSet = { ...PSTNDetails, ...IndividualDetails };
  let arrData: any = {
    RenderJoined: [],
    RenderInvited: []
  };
  directSet && Object.keys(directSet)?.map((gKey: any) => {
    if ((((directSet[gKey]?.caller_id)?.toString()?.toLowerCase().includes(findText)) || ((gKey).toString().toLowerCase().includes(findText)))) {

      if ((directSet[gKey].callStatus === 'Connected') || (directSet[gKey].callStatus === 'Dialing') || (directSet[gKey].callStatus === 'Ringing')) {
        Object.assign(arrData.RenderJoined, { [gKey]: directSet[gKey] });
      }
      else if ((directSet[gKey].callStatus === "Unattended") || (directSet[gKey].callStatus === "Rejected")) {
        Object.assign(arrData.RenderInvited, { [gKey]: directSet[gKey] });
      }
    }
  });


  GroupDetails && Object.keys(GroupDetails)?.map((gKey: any) => {
    let newKey: any = GroupDetails[gKey];
    Object.keys(newKey)?.map((member: any) => {
      if (((newKey[member].caller_id?.toLowerCase().includes(findText)) || (member?.toLowerCase().includes(findText)))) {
        if ((newKey[member].callStatus === "Connected") || (newKey[member].callStatus === 'Dialing') || (newKey[member].callStatus === 'Ringing')) {
          let underGroups: any = findBelongsGroups(member, activeCall);
          newKey[member].underGroups = underGroups;
          Object.assign(arrData.RenderJoined, { [member]: newKey[member] });
        }
        else if ((newKey[member].callStatus === 'Disconnected') || (newKey[member].callStatus === "Unattended") || (newKey[member].callStatus === "Rejected")) {
          Object.assign(arrData.RenderInvited, { [member]: newKey[member] });
        }
      };
    });

  });


  return arrData;
}

export const getMOM = () => {
  let { detailPage } = store.getState().meetingReducer;
  if (detailPage.status === "Completed") {
    axios.get(`https://mom.worktual.co.uk/read_root?uuid=${detailPage.uuid}`)
      .then((response: any) => {
        if (response) {
          let data: any = response.data.MOM;
          if (data) {
            storeMOM(data["over_all summary"], data["participant_mom"], data["key_words"], data["participant_high_lights"], false);
            storeEditMOM(data["edited_state"] ? data["edited_mom"] : data["over_all summary"][0].summary, data["edited_state"]);
            storeEditMOMCopy(data["edited_mom"], data["edited_state"]);
            storeTranscript(data["transcript"], false, 0);
            storeActions(data["Action_item"], false, 0);           
            storePerformance(data["Performance_metrics"], false, 0);
          }
          else {
            storeMOM([], [], [], [], false);
            storeEditMOM("", false);
            storeTranscript([], false, 0);
            storeActions([], false, 0);
            storePerformance([], false, 0);

          }
        }
      })
      .catch((err: any) => {
        storeMOM([], [], [], [], false);
        storeEditMOM("", false);
        storeTranscript([], false, 0);
        storeActions([], false, 0);
      });
  }
}

export const createClip=(val:any)=>{
  let token: string = store.getState().loginReducer.token;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };

  axios.post(`${config().MEET_RESTAPI_URL}/create_recording_clip`,val,{headers:authkey})
  .then((response: any) => {
    if (response.data.statusCode) {
       fetchClips(val.meeting_id);
       toastInformation('Clip added successfully');
    }
  })


}

export const createPlayList=(data:any)=>{
  let token: string = store.getState().loginReducer.token;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };

  axios.post(`${config().MEET_RESTAPI_URL}/create_and_edit_playlist `,data,{headers:authkey})
  .then((response: any) => {
    if (response) {
       fetchPlayLists();
       toastInformation('Clips created successfully');
    }
  })
}
export const fetchClips=(id:any)=>{
  const {recordDetailPage}:any=store.getState().meetingReducer;
  let token: string = store.getState().loginReducer.token;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };

  axios.get(`${config().MEET_RESTAPI_URL}/get_recording_clips/${recordDetailPage?.v_id}/${id}`,{headers:authkey})
  .then((response: any) => {
    if (response) {
      setRecClips(response.data.result);
    }
  })


}

export const resetValue=()=>{
  const {aiSessionId}:any=store.getState().chatReducer;
  store.dispatch({
    type:Types.SET_ARR_BUFFER,
    payload:{
      aiSessionId:aiSessionId,
      arrayBuffer:[],
      intent:"",
      aiAssistMessage:""
    }
  })
}

export const fetchPlayLists=()=>{
  const {recordDetailPage}:any=store.getState().meetingReducer;
  let token: string = store.getState().loginReducer.token;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };

  axios.get(`${config().MEET_RESTAPI_URL}/get_playlist_id `,{headers:authkey})
  .then((response: any) => {
    if (response) {
      setRecPlayLists(response.data.result);
    }
  })


}

export const setRecClips=(data:any)=>{
  store.dispatch({
    type:Types.CLIPS_LIST,
    payload:{clips:data}
  })
}

export const setRecPlayLists=(data:any)=>{
  store.dispatch({
    type:Types.PLAY_LIST,
    payload:{playLists:data}
  })
}

export const setClipsToPlayList=(id:any,sortOrder:any)=>{
  const {recordDetailPage}:any=store.getState().meetingReducer;
  let token: string = store.getState().loginReducer.token;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };

  axios.get(`${config().MEET_RESTAPI_URL}/get_playlist_clips_by_id/${sortOrder}/${id}`,{headers:authkey})
  .then((response: any) => {
    if (response) {
      // setRecClips(response.data.result);
        storePlayListPage(response);
    }
  })


}


export const getChatSummary=(details:any)=>{
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let data:any={};
  const userDetails = userInfo();
  data.user_id=parseInt(loggedUserDetails.sip_login_id);
  data.chat_id=details?.team_id
  ? details?.team_id?.toString()
  : generateChatID(userDetails?.fromID, details?.sip_login_id);
  data.chat_type=details?.team_id ? "team" : "onetoone";
  data.sipid=details?.team_id
  ? details?.team_id?.toString() : details?.sip_login_id.toString();
  data.part_name=details?.team_id ? details?.team_name : details?.caller_id;
  store.dispatch({
      type:Types.STORE_CHAT_SUMMARY, 
      payload:{
        chatSummary:{}
      }
    })
    axios.post(`https://sttapi.worktual.co.uk/unreadchat_summary`,data)
      .then((response: any) => {
        if (response) {
             storeChatSummary(response,"summary");
        }
      })
      .catch((err: any) => {
      
      });
  
}

export const getUnreadCompose=(chatDetails:any)=>{
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let data:any={};
  const userDetails = userInfo();
  data.chatid=chatDetails?.team_id
  ? chatDetails?.team_id?.toString()
  : generateChatID(userDetails?.fromID, chatDetails?.sip_login_id);
  data.message ="";
  data.convert_type="message_compose";
  data.userid=parseInt(loggedUserDetails.sip_login_id);
  data.sipid=chatDetails?.team_id
  ? chatDetails?.team_id?.toString() : chatDetails?.sip_login_id.toString();

    axios.post(`https://sttapi.worktual.co.uk/message_convert`,data)
      .then((response: any) => {
        if (response) {
             storeChatSummary(response.data,"unread");
        }
      })
      .catch((err: any) => {
      
      });
}

export const getComposedMessage=(msg:any,type:any,chatDetails:any)=>{
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
let data:any={};
const userDetails = userInfo();
data.chatid=chatDetails?.team_id
? chatDetails?.team_id?.toString()
: generateChatID(userDetails?.fromID, chatDetails?.sip_login_id);
data.message=msg;
data.userid=parseInt(loggedUserDetails.sip_login_id);
data.sipid=chatDetails?.team_id
? chatDetails?.team_id?.toString() : chatDetails?.sip_login_id.toString();
data.convert_type=type==="Formal" ? "Formal_text" : type==="Regenerate" ? "Regenerate_text" : type==="Concise" ? "consice_text" : type === "Expand" ? "Expand_text" : type === "Informal" ? "Friendly_text" : "" ;

axios.post(`https://sttapi.worktual.co.uk/message_convert`,data)
    .then((response: any) => {
      if (response) {
           storeChatSummary(response.data,"composedmsg");
      }
    })
    .catch((err: any) => {
    
    });

}

export const storeChatSummary=(res:any,type:any)=>{
 if(type ==="composedmsg"){ 
  let data:any={};
  data.toPerson=res.chatid;
  data.composed=res.response;
  data.original=res.message;
  data.type="compose";
  store.dispatch({
    type:Types.STORE_COMPOSED_MSG,
    payload:{
      composedMsg:data
    }
  })}
  else if(type ==="unread"){ 
    let data:any={};
    data.toPerson=res.chatid;
    data.composed=res.response;
    data.original="";
    data.type ="unread";
    store.dispatch({
      type:Types.STORE_COMPOSED_MSG,
      payload:{
        composedMsg:data
      }
    })}
  else if(type ==="summary"){
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    let det:any={};
  
    det.fromperson=res.data.sipid;
    det.summary=res.data.unreadchat_summary;
    det.chatId=res.data.chat_id;
    det.name=res.data.part_name;

  
    store.dispatch({
      type:Types.STORE_CHAT_SUMMARY,
      
      payload:{
        chatSummary:det
      }
    })
    let sip:any=res.data.chat_type ==="team" ?"con"+res.data.sipid : res.data.sipid;
    recentChatList[sip].chatSummary=res.data.unreadchat_summary;
    store.dispatch({
      type: actionTypes.RECENT_MESSAGE_LIST,
      payload: {
          recentChatList: recentChatList,
          recentLoading: true
      }
  });
  }
}

export const editSummary = (data: any) => {

  let token: string = store.getState().loginReducer.token;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };


  let { detailPage } = store.getState().meetingReducer;
  if (detailPage.status === "Completed") {
    axios.post(`${config().API_URL}/urmeet/v2/transcript/update_mom?uuid=${detailPage.uuid}`, data, { headers: authkey })
      .then((response: any) => {
        if (response) {
          getMOM();
        }
      })
      .catch((err: any) => {
        storeMOM([], [], [], [], false);
        storeTranscript([], false, 0);
        storeActions([],false,0)
      });
  }
}

export const frameMultiGroupCall = (guid: string, status: string, internal: Array<any>, external?: any) => {
  const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
  let extensions: Array<any> = [], groups: Array<any> = [];
  let extNum: Array<any> = (external !== '' && external) ? external.map((num: any) => { if (num !== ',') { return ((status === 'Join' || status === 'SwitchToGroup' ||status === 'Merge') ? num : `"${num}"`) } }) : [];
  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let { activeLogs } = store.getState().callReducer || {};
  let index: number = _.findIndex(currentCallList, { isCurrent: true });
  let GroupDetails = {}, IndividualDetails = {}, PSTNDetails = {}, groupNames = {}, groupCollect: any = [];
  if (status === 'SwitchToGroup') {
    let ext = (currentCallList[index]?.bound === 'OUT') ? currentCallList[index].to : currentCallList[index].from;
    ext.length > 3 ? external.push(ext) : internal.push(ext)
  }

  internal.forEach((user: any) => {
    let alterUser = user.toString();
    if ((alterUser).includes('con') || (alterUser.length !== 3)) {
      let groupId: string = user.replace('con', '');
      groups.push(`"${groupId}"`)
      let grpInfo: any = [];
      if (status !== 'Rejoin'&&status!=='Merge') {
        grpInfo = filterGrpContact((groupId), false);
        Object.assign(GroupDetails, { [grpInfo.team_id]: grpInfo.members });
        Object.assign(groupNames, { [grpInfo.team_id]: grpInfo.team_name });
      }

      if (status === 'Join' || status === 'SwitchToGroup') {
        let groupSet: any = {};
        groupSet.GroupId = (grpInfo.team_id)?.toString();
        groupSet.GroupName = (grpInfo.team_name)?.toString();
        groupSet.Extensions = Object.keys(grpInfo.members)
        groupCollect.push(groupSet);
      }

    }
    else {
      extensions.push(((status === 'Join' || status === 'SwitchToGroup'|| status === 'Merge') ? (user.length > 3 ? user : (user).toString()) : `"${user}"`));
      let singleInfo = filterContactForCall(user.toString(), true)
      Object.assign(IndividualDetails, { [singleInfo.ext]: singleInfo });
    }
  });
  let header: any = {}, isPstn = extNum.length > 0, isGroup = groups.length > 0, isExt = extensions.length > 0;
  if (isPstn) {
    external?.forEach((item: any) => {
      let pstnObj: any = {
        mute: 'unmute', hold: 'Unhold',
        callStatus: 'Dialing',
        UserDeviceType: ''
      };
      Object.assign(PSTNDetails, { [item]: pstnObj });
    });
  }

  if (status === 'join' || status === 'Rejoin') {
    header = `{"TeamID":"${guid}","DomainId":"${loggedUser.domain_id}","Status":"${status}",` + (isGroup ? `"GroupIDs":[${groups}]${(isPstn || isExt) ? ',' : ''}` : '') + (isExt ? `"Extensions":[${extensions}]${(isPstn) ? ',' : ''}` : '') + (isPstn ? `"Pstns":[${extNum}]` : '') + `}`
  }
  else {
    header.TeamID = guid;
    header.Status = status;
    header.GroupIDs = groupCollect;
    header.Extensions = extensions;
    header.Pstns = extNum;
    if (status === 'SwitchToGroup'||status === 'Merge') {
      header.Host = (loggedUser.ext)?.toString();
      header.DomainName = loggedUser?.domain_name;
      header.DomainId = (loggedUser?.domain_id)?.toString();
    }
    if (status === 'Merge') {
      let normlInd: number = _.findIndex(currentCallList, { isGroupCall: false });
      header.MergeRequestId=currentCallList[normlInd]?.bound==="IN"?(currentCallList[normlInd]?.guid):(currentCallList[normlInd]?.switchCallId);
    }
  }
  let grouped: any = {};
  grouped['PSTNDetails'] = PSTNDetails;
  grouped['IndividualDetails'] = IndividualDetails;
  grouped['GroupDetails'] = GroupDetails;
  grouped['GroupNames'] = groupNames;

  if (status === 'SwitchToGroup'||status === 'Merge') {
    currentCallList[index]['isHostId'] = (loggedUser.ext).toString();
    currentCallList[index]['isGroupHost'] = true;
    currentCallList[index]['isGroupCall'] = true;
    currentCallList[index]['groupCallInfo'] = grouped;
    currentCallList[index]['groupNames'] = groupNames;

    store.dispatch({
      type: Types.UPDATDE_CALL_LIST,
      payloads: currentCallList
    });
  }

  return { header, grouped };
}

export const singleGroupCall = (guid: string, groupID: any) => {
  let grpInfo: any = filterGrpContact((groupID), true);
  const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
  let groupNames = {};
  let header: any = '';
  let GroupDetails = {};
  let grouped: any = {};
  let groupSet: any = {};
  let groupCollect: any = [];
  groupSet.GroupId = (grpInfo.team_id).toString();
  groupSet.Extensions = Object.keys(grpInfo.members)
  groupCollect.push(groupSet);
  Object.assign(GroupDetails, { [grpInfo.team_id]: grpInfo.members });
  Object.assign(groupNames, { [grpInfo.team_id]: grpInfo.team_name });
  grouped['PSTNDetails'] = {};
  grouped['IndividualDetails'] = {};
  grouped['GroupDetails'] = GroupDetails;
  grouped['GroupNames'] = groupNames;
  header = `{"TeamID":"${guid}","DomainId":"${loggedUser.domain_id}","Status":"${'join'}","GroupIDs":["${groupID}"]}`;
  return { header, grouped };
};

export const findTeamMembers = (team_members: any, checkLoggedIn: boolean) => {
  let memberList: any = team_members?.replaceAll(/\s/g, '').split(',');
  let result: any = {};
  let { userdetails }: LoginState = store.getState().loginReducer;
  Array.isArray(memberList) && memberList.map((mem: any) => {
    let userCheck: boolean = false;
    if (checkLoggedIn) {
      userCheck = userdetails?.sip_login_id.toString() === mem.toString()
    }

    if (!userCheck) {
      let conDetails: any = getTeamMemberContact(mem);
      if (conDetails !== undefined && conDetails !== null) {
        let filterObj: any = {
          mute: 'unmute',
          hold: 'Unhold',
          UserDeviceType: '',
          ext: conDetails['ext'],
          callStatus: userdetails.ext === conDetails.ext ? 'Connected' : 'Dialing',
          ImageURL: conDetails['ImageURL'],
          caller_id: conDetails['caller_id'],
          user_status: conDetails['user_status'],
          sip_login_id: conDetails['sip_login_id'],
          underGroups: []
        };
        Object.assign(result, { [conDetails.ext]: filterObj })
      }
    }
  });
  return result;
}

export const filterContactForCallNew = (ext: any, obj: any, initiating: boolean, hostId: string) => {
  let loggedUserDetails: any = store.getState().loginReducer.userdetails || [];
  let contactReducer: contacts = store.getState().contactReducer || [];
  let companyContact: Array<workContact> = contactReducer.workContacts || [];

  if (ext.toString() === loggedUserDetails.ext.toString()) {
    obj['ext'] = loggedUserDetails.ext;
    obj['ImageURL'] = loggedUserDetails?.profile_url && loggedUserDetails?.profile_url;
    obj['caller_id'] = loggedUserDetails['caller_id'] || ext;
    obj['user_status'] = loggedUserDetails['user_status'] || '';
    obj['sip_login_id'] = loggedUserDetails['sip_login_id'] || '';
    obj['underGroups'] = [];

  }
  else {
    let contactdetail: any = companyContact.find(obj => (obj.ext).toString() === ext) || [];
    obj['ext'] = contactdetail['ext'] || ext;
    obj['ImageURL'] = contactdetail['ImageURL'] || '';
    obj['caller_id'] = contactdetail['caller_id'] || ext;
    obj['user_status'] = contactdetail['user_status'] || '';
    obj['sip_login_id'] = contactdetail['sip_login_id'] || '';
    obj['underGroups'] = [];

    if (initiating) {
      obj['mute'] = "unmute";
      obj['hold'] = "Unhold";
      obj['UserDeviceType'] = '';
      obj['callStatus'] = ((hostId).toString() === ext.toString() ) ? 'Connected' : 'Dialing';
      obj['audioPitch'] = 0;
      obj['isSpeaking'] = false;
      obj['underGroups'] = [];
    }
  }
  return obj
};

export const filterContactForCall = (ext: any, initiating: boolean) => {
  let loggedUserDetails: any = store.getState().loginReducer.userdetails || [];
  let contactReducer: contacts = store.getState().contactReducer || [];
  let companyContact: Array<workContact> = contactReducer.workContacts || [];
  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let index: number = _.findIndex(currentCallList, { isCurrent: true });
  let result: any = {};
  if (ext.toString() === loggedUserDetails.ext.toString()) {
    return loggedUserDetails;
  }
  else {
    let contactdetail: any = companyContact.find(obj => (obj.ext).toString() === ext);
    result['ext'] = contactdetail['ext'];
    result['ImageURL'] = contactdetail['ImageURL'];
    result['caller_id'] = contactdetail['caller_id'];
    result['user_status'] = contactdetail['user_status'];
    result['sip_login_id'] = contactdetail['sip_login_id'];
    let previousPerson: any = ''
    if (index !== -1) {
      previousPerson = (currentCallList[index]?.bound === 'OUT') ? currentCallList[index].to : currentCallList[index].from;
    }
    if (initiating) {
      result['mute'] = 'unmute';
      result['hold'] = 0;
      result['UserDeviceType'] = '';
      result['callStatus'] = ext === (previousPerson).toString() ? 'Attended' : 'Dialing';
      result['audioPitch'] = 0;
      result['isSpeaking'] = false;
      result['underGroups'] = [];
    }
    return result
  }
};

export const filterGrpContact = (teamId: any, checkLoggedIn: boolean) => {
  let { teamContacsnew }: contacts = store.getState().contactReducer || [];
  let teamContactsValues: any = teamContacsnew ? Object.values(teamContacsnew) : [];
  let contactdetail: any = teamContactsValues.find((obj: any) => (obj.team_id).toString() === teamId.toString() || (obj.team_name).toString() === teamId.toString());
  let members = findTeamMembers(contactdetail.team_members, checkLoggedIn)
  let result: any = {};
  result['team_name'] = contactdetail.team_name;
  result['members'] = members;
  result['team_id'] = contactdetail.team_id
  return result;
};

export const filterGrpProfile = (teamId: any) => {
  let { teamContacsnew }: contacts = store.getState().contactReducer || [];
  let teamContactsValues: any = teamContacsnew ? Object.values(teamContacsnew) : [];
  let contactdetail: any = teamContactsValues.find((obj: any) => (obj.team_id).toString() === teamId.toString() || (obj.team_name).toString() === teamId.toString());
  return contactdetail && contactdetail?.profile_image_url  ? contactdetail?.profile_image_url  : '';
};

export const updateOldWithNewObj = (existing: any, incoming: any) => {

  let pstnUserName:any
  if(incoming.userType === "Pstns") {
    pstnUserName= Object.keys(existing);
    pstnUserName.forEach((data:any)=>{
      if(existing[data]?.callStatus === 'Disconnected'){
        return existing[data]?.caller_id || ''
      }
    })
  }
  
  Object.keys(existing).forEach((obj: any) => {
    if (incoming.hasOwnProperty(obj)) {
      for (var propertyName in incoming[obj]) {
        if (incoming[obj][propertyName] === 'Disconnected') {
          let contactDetails = filterContact(obj.toString());
          if (contactDetails && contactDetails.caller_id) {
            const { caller_id }: any = contactDetails;
            toastInformation(`${caller_id} left the team call`, 'success');
          } else {
            existing[obj][propertyName] = incoming[obj][propertyName];
            toastInformation(`${pstnUserName} left the team call`, 'success');
        }
        } else if (incoming[obj][propertyName] === 'Removed') {
          delete existing[obj];
        }
        existing[obj][propertyName] = incoming[obj][propertyName];

      }
    }
  }
  );
  return existing;
};


export const findTileSize = (group: any) => {
  let tileSize = 'one';
  if (group?.length > 3) tileSize = 'four';
  else if (group?.length === 3) tileSize = 'three';
  else if (group?.length === 2) tileSize = 'two';


  // switch (group.length) {
  //   case 1:
  //     tileSize = 'one';
  //     break;
  //   case 2:
  //     tileSize ='two'
  //     break;
  //   case 3:
  //      day = "Tuesday";
  //     break;
  //   case 3:
  //     day = "Wednesday";
  //     break;

  // }
  return tileSize;
}

export const filterUserStatus = (groupCallInfo: any, status1: string, status2?: string, status3?: string, status4?: string) => {
  let { GroupDetails, PSTNDetails, IndividualDetails } = groupCallInfo || {};
  const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
  let filteredUsers: Array<any> = [];
  Object.keys(GroupDetails).map((gKey: any) => {
    let newKey: any = GroupDetails[gKey];
    Object.keys(newKey).map((member: any) => {
      if (((newKey[member].callStatus) === status1 || (newKey[member].callStatus) === status2 ||
        (newKey[member].callStatus) === status3 || (newKey[member].callStatus) === status4) && loggedUser.ext !== newKey) {
        if (newKey[member]) { filteredUsers.push(newKey[member]); }
      }
    })
  });

  Object.keys(IndividualDetails).map((gKey: any) => {

    if ((IndividualDetails[gKey].callStatus) === status1 || (IndividualDetails[gKey].callStatus) === status2 ||
      (IndividualDetails[gKey].callStatus) === status3 || (IndividualDetails[gKey].callStatus) === status4) {
      if (IndividualDetails[gKey]) { filteredUsers.push(IndividualDetails[gKey]); }
    }
  });

  Object.keys(PSTNDetails).map((gKey: any) => {
    if ((PSTNDetails[gKey].callStatus) === status1 || (PSTNDetails[gKey].callStatus) === status2 ||
      (PSTNDetails[gKey].callStatus) === status3 || (PSTNDetails[gKey].callStatus) === status4) {
      if (PSTNDetails[gKey]) { filteredUsers.push(PSTNDetails[gKey]); }
    }
  });
  return filteredUsers;

};

export const groupCurrentUserMute = () => {
  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let index: number = _.findIndex(currentCallList, { isCurrent: true });
  if (index !== -1) {

    if (currentCallList[index].isGroupCall) {
      //let ext: string = (currentCallList[index].bound === "IN") ? currentCallList[index].to : currentCallList[index].from;
      const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
      let changeMute: string = currentCallList[index].muteState ? 'unmute' : 'mute';

      let filtered: any = filterUserFromGroup(currentCallList[index].groupCallInfo, (loggedUser.ext).toString());
      groupSendFramer(changeMute, false, (loggedUser.ext).toString(), false);
      // if (!currentCallList[index].muteState) {
      //   Mute_AudioCall(currentCallList[index].useragent);
      //   currentCallList[index].muteState = true;
      // }
      // else {
      //   currentCallList[index].muteState = false;
      //   UnMute_AudioCall(currentCallList[index].useragent);
      // }

    }
    else {
      muteCall();
    }

  }

}

export const setActiveLogs = (incomingInfo: any, callHeader?: any) => {

  let incomingCall: any = incomingInfo
  let { activeLogs } = store.getState().callReducer || {};
  let idPos: number = activeLogs.findIndex(
    (ele: any) => ele.guid === incomingCall.guid
  );
  // let currentCallInfo:calldetail[] = store.getState().updatedCallList.callDetails || [];
  // let incomingCall:any = currentCallInfo.find((e: calldetail) => (e.guid === incomingGuid));

  if (idPos !== -1) {
    activeLogs[idPos].callStatus = incomingCall.callStatus
  } else {

    let callProfile: any = frameCallProfile(incomingCall);
    incomingCall['combinedNames'] = callProfile.combinedNames || [];
    incomingCall['caller_id'] = callProfile.callerName;
    incomingCall['callStatus'] = incomingCall.callStatus || 'Active';
    incomingCall['isHost'] = incomingCall.isGroupHost;
    incomingCall['isHostId'] = incomingCall.isHostId;
    incomingCall['connectingStatus'] = incomingCall.connectingStatus;
    incomingCall['ImageURL'] = callProfile.ImageURL;
    incomingCall['guid'] = incomingCall.guid
    activeLogs.push(incomingCall);

  }
  storeActiveLogs(activeLogs);
}

export const removeActiveLog = (foundLog: any) => {
  let { activeLogs } = store.getState().callReducer || {};

  activeLogs.map(
    (ele: any, index: number) => {

      if (ele.guid === foundLog.guid && ele.callStatus !== 'Rejoin') {
        activeLogs.splice(index, 1)
      } else if (ele.callStatus === 'Hold') {
        ele.callStatus = 'Active'
      }
    }
  );
  storeActiveLogs(activeLogs);
}

export const singleSendFramer = (type: any, user: any, groupName: any, pitch?: number) => {
  let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
  const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let index: number = _.findIndex(currentCallList, { isCurrent: true });
  if (index !== -1) {

    let header: any = {}
    if (groupName !== '' && groupName !== undefined) {
      let { team_id }: any = filterGrpContact((groupName), false);
      let groupCollect: any = [];
      let groupSet: any = {};
      let groupId: Array<any> = [];
      let ext: Array<any> = [];
      ext.push((user.ext).toString());
      groupId.push((team_id).toString());
      groupSet.GroupId = groupId;
      groupSet.Extensions = ext;
      groupCollect.push(groupSet);
      header.TeamID = currentCallList[index].guid;
      header.GroupIDs = groupCollect;
      header.Extensions = [];
      header.Pstns = [];
    }
    else {
      let single = [];
      header.TeamID = currentCallList[index].guid;
      header.GroupIDs = [];
      if (user.length > 3) {
        single.push(user.toString())
        header.Extensions = [];
        header.Pstns = single;
      }
      else {
        single.push(user.toString());
        header.Extensions = single;
        header.Pstns = [];
      }

    }
    if (typeof (type) !== 'boolean') {
      header.Status = type
    }
    else {
      header.isSpeaking = type;
      header.audioPitch = pitch;
    }

    socketservice.groupCallSendEvent(header);
    if (typeof (user) === 'string') {
      let filtered: any = filterUserFromGroup(currentCallList[index].groupCallInfo, user);
      user = filtered.user;
    }
    user.callStatus = 'Dialing'
    updateOldWithNewObj(currentCallList[index].groupCallInfo, user);

  }

}


export const filterUserFromGroup = (groupCallInfo: any, neededExt: any) => {
  let { GroupDetails, PSTNDetails, IndividualDetails } = groupCallInfo || {};
  neededExt = neededExt.toString();
  let filteredUser: any = {};
  Object.keys(GroupDetails).map((gKey: any) => {
    let newKey: any = GroupDetails[gKey];
    Object.keys(newKey).map((member: any) => {
      if ((newKey[member].ext).toString() === neededExt) {
        if (newKey[member]) {
          filteredUser['user'] = newKey[member]
          filteredUser['groupName'] = gKey.toString()
          return filteredUser;
        }
      }
    })
  });

  Object.keys(IndividualDetails).map((gKey: any) => {
    if (gKey.toString() === neededExt) {
      filteredUser['user'] = IndividualDetails[gKey];
      filteredUser['groupName'] = ''
      return filteredUser;

    }
  });
  Object.keys(PSTNDetails).map((gKey: any) => {
    if (gKey === neededExt) {
      if (PSTNDetails[gKey]) {
        filteredUser['user'] = (PSTNDetails[gKey]);
        filteredUser['groupName'] = ''
        return filteredUser;
      }
    }
  });

  return filteredUser || {};
};

export const frameCallProfile = (activeCallDetail: any) => {
  try {


    let callerName: string = '', ext: string = '', callduration: string = '', ImageURL: string = '', combinedNames: Array<any> = [];
    let isGroup: boolean = false, isGrpHost: boolean = false;
    if (activeCallDetail?.isGroupCall) {
      let { groupCallInfo, groupNames } = activeCallDetail;
      let groupCallers: Array<any> = [];
      let IndividualCallers: Array<any> = [];
      Object.keys(groupNames).forEach(element => {
        return groupCallers.push(groupNames[element]);
      });
      Object.keys(groupCallInfo?.IndividualDetails).forEach(element => {
        let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
        return filterContact(element)?.caller_id !== loggedUserDetails?.caller_id ? IndividualCallers.push(filterContact(element)?.caller_id) : {}
      });
      // let pstnCallers: Array<any> = Object.keys(groupCallInfo?.PSTNDetails);
      let pstnCallers: Array<any> = Object.keys(groupCallInfo?.PSTNDetails)
        .filter(key => groupCallInfo?.PSTNDetails[key].callStatus !== 'Disconnected');

      combinedNames = combinedNames.concat(groupCallers);
      combinedNames = combinedNames.concat(pstnCallers);
      combinedNames = combinedNames.concat(IndividualCallers);
      callerName = combinedNames.toString();
      isGroup = activeCallDetail.isGroupCall;
      isGrpHost = activeCallDetail.isGroupHost;
      ImageURL = activeCallDetail?.ImageURL || '';
    }
    else {
      if (!_.isEmpty(activeCallDetail)) {
        let callerID: any = (activeCallDetail?.bound === 'OUT') ? activeCallDetail.to : activeCallDetail.from;
        callerName = activeCallDetail?.contact['caller_id'] || callerID;
        ext = callerID;
        ImageURL = activeCallDetail?.contact['ImageURL'] || '';
        // ImageURL = activeCallDetail?.ImageURL || '';
      }
    }
    callduration =activeCallDetail &&  activeCallDetail.callduration ? activeCallDetail.callduration : "00.00";
    return {
      callerName: callerName,
      callduration: callduration, ext: ext,
      ImageURL: ImageURL, isHold:
        activeCallDetail.holdState,
      combinedNames: combinedNames,
      muteState: activeCallDetail.muteState,
      holdState: activeCallDetail.holdState,
      guid: activeCallDetail.guid,
      isGroupCall: isGroup || false,
      isGroupHost: isGrpHost,
      isHostId: activeCallDetail.isHostId || '',
      connectingStatus: activeCallDetail.connectingStatus

    };
  } catch (error) {
    console.log('frame_Data error is ---', error)
  }

};

export const setActiveStatus = (Id: string, status: string) => {
  let { activeLogs } = store.getState().callReducer || {};
  let index: number = _.findIndex(activeLogs, { guid: Id });
  activeLogs[index].callStatus = status
  storeActiveLogs(activeLogs);

}

export const setConnectingStatus = (Id: string, connectingStatus: string) => {
  let { activeLogs } = store.getState().callReducer || {};
  let index: number = _.findIndex(activeLogs, { guid: Id });
  activeLogs[index].connectingStatus = connectingStatus;
  storeActiveLogs(activeLogs);

}

export const callInitStore = (currentCallList: any) => {
  let history = window.location.href || ''
  let callReducer = store.getState().updatedCallList || [];
  store.dispatch({
    type: Types.UPDATE_CALL_INFO,
    payloads: {
      callDetails: currentCallList,
      minimizedWindow: (history.includes('calls')) ? (currentCallList.length > 1) ? true : false : true,
      isCallActive: (currentCallList.length === 1) ? true : callReducer.isCallActive,
      isWindowSlide: callReducer.minimizedWindow ? false : callReducer.isWindowSlide,
      isCallFullScreen: (history.includes('calls')) ? true : callReducer.isAddCall ? true : false,
      centerWindow: (history.includes('calls')) ? 'callWindow' : (callReducer.minimizedWindow) ? callReducer.centerWindow : 'callWindow',
      rightSideWindow: (history.includes('calls')) ? 'participantList' : callReducer.minimizedWindow ? callReducer.rightSideWindow : 'participantList'
    }
  });
}

export const groupSendFramer = (status: any, isGroup: any, key: any, isHost: boolean) => {
  let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
  const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let index: number = _.findIndex(currentCallList, { isCurrent: true });
  if (index !== -1) {
    let header: any = { userId: key, userType: '', Status: status };
    header.TeamID = currentCallList[index].guid;
    (isGroup) ? (header.userType = 'Group') : (header.userType = 'Extension');
    if (status === 'mute' || status === 'unmute') {
      if (status === 'mute' || (key.toString()) === (loggeduser.ext).toString()) {
        header.actionType = 'mute';
        header.isHostDoer = isHost;
        socketservice.groupCallMuteStatus(header);
      } else {
        toastInformation('Future Implementation', 'warning')
      }

    }
    else {
      header.Extensions = [];
      header.GroupIDs = [];
      header.Pstns = [];
      socketservice.groupCallSendEvent(header);
    }
  }
}


export const setUserStausInGroupCall = (type: string, updatingStatus: any, neededExt: any, groupCallInfo: any) => {
  try {

    let { GroupDetails, PSTNDetails, IndividualDetails, Host, GroupIDs, Extensions, Pstns } = groupCallInfo || {};
    neededExt = neededExt.toString();
    if (Object.keys(GroupDetails).length > 0) {
      Object.keys(GroupDetails).map((gKey: any) => {
        let newKey: any = GroupDetails[gKey];
        Object.keys(newKey).map((member: any) => {
          if ((member).toString() === neededExt) {

            if (type === 'mute' || type === 'isSpeaking') {
              newKey[member][type] = updatingStatus;
            }
            else if (type === 'Remove') {
              delete newKey[member];
              let extIndex: number = (GroupIDs[gKey]?.Extensions).indexOf(neededExt);
              if (extIndex > -1) {
                GroupIDs[gKey]?.Extensions.splice(extIndex, 1)
              }
            }
          }

        })
      });
    }

    if (Object.keys(IndividualDetails).length > 0) {
      Object.keys(IndividualDetails).map((gKey: any) => {
        if (gKey.toString() === neededExt) {
          if (type === 'mute' || type === 'isSpeaking') {
            IndividualDetails[gKey][type] = updatingStatus;
          }
          else if (type === 'Remove') {
            delete IndividualDetails[gKey];
            let extIndex: number = (Extensions).indexOf(neededExt);
            if (extIndex > -1) {
              Extensions.splice(extIndex, 1)
            }
          }
        }
      });
    }
    if (Object.keys(PSTNDetails).length > 0) {
      Object.keys(PSTNDetails).map((gKey: any) => {
        if (gKey.toString() === neededExt) {
          if (type === 'mute') {

            PSTNDetails[gKey][type] = updatingStatus;
          }
          else if (type === 'Remove') {
            delete PSTNDetails[gKey];
            let extIndex: number = (Pstns).indexOf(neededExt);
            if (extIndex > -1) {
              Pstns.splice(extIndex, 1)
            }
          }
        }
      });
    }
    let filteredUser: any = {
      GroupDetails: GroupDetails || {},
      IndividualDetails: IndividualDetails || {},
      PSTNDetails: PSTNDetails || {}
    }
    return filteredUser || {};

  }
  catch (err) {
    return err;
  }
};

export const getCombinedNames=(detail:any, data: string)=>{
  let comb_name:any=[];
  let contactReducer: contacts = store.getState().contactReducer || [];
  let { userdetails }: LoginState = store.getState().loginReducer || [];
  let companyContact: Array<workContact> = contactReducer.workContacts || [];
  Object.keys(detail.IndividualDetails).map((ele:any)=>{
    companyContact.filter((obj:any)=>{
      if( obj.ext?.toString() === ele){comb_name.push(obj?.caller_id)}
    })
  })
  if(data === "combinedNames"){
    comb_name=comb_name;
  return comb_name;
  }
  else{
    comb_name = userdetails.caller_id+ ", " +comb_name.join(", ");
    return comb_name;
  } 

}

export const filterSingleStatusInGroup = (groupCallInfo: any, status: string, hostId: string) => {
  let { GroupDetails, IndividualDetails } = groupCallInfo || {};
  let filteredUsers: Array<any> = [];
  Object.keys(GroupDetails).map((gKey: any) => {
    let newKey: any = GroupDetails[gKey];
    Object.keys(newKey).map((member: any) => {
      if (((newKey[member].callStatus) === status) && hostId !== (member).toString()) {
        if (newKey[member]) { filteredUsers.push(newKey[member]); }
      }
    })
  });

  Object.keys(IndividualDetails).map((gKey: any) => {
    if ((IndividualDetails[gKey].callStatus) === status && hostId !== (gKey.toString())) {
      if (IndividualDetails[gKey]) { filteredUsers.push(IndividualDetails[gKey]); }
    }
  });
  return filteredUsers;
};

export const findBelongsGroups = (ext: string, CallInfo: any) => {
  let { GroupDetails }: any = CallInfo.groupCallInfo || {};
  let underGroups: any = [];
  Object.keys(GroupDetails).map((gKey: any) => {
    let newKey: any = GroupDetails[gKey];
    if (Object.keys(newKey).includes(ext)) {
      underGroups.push(CallInfo.groupNames[gKey]);
    }
  });
  return underGroups;
};
export const keyCopy = () => {

}


export const textToText = (text: any, isdwld: any, title?: any, shareCon?: any, extval?: any) => {
  let bodyText: any = "";
  let { transcript,actionsData } = store.getState().meetingReducer;
  if (text.includes("Transcript") && transcript) {
    transcript.forEach((element: any) => {
      bodyText += element.name + ":\r\n" +
        "\t" + element.text + "\r\n";
    });
    textConvert(bodyText, isdwld, text, title, shareCon, extval)
  }
  if (text.includes("Summary")) {
    let transAg: any = document.getElementById('summary');
    bodyText = transAg?.innerText;
    textConvert(bodyText, isdwld, text, title, shareCon, extval);
  }
  if (text.includes("Highlight") && meetingHighlights) {
    meetingHighlights.forEach((element: any) => {
      bodyText += element.name + ":\r\n" +
        "\t" + element.summary + "\r\n";
    });
    textConvert(bodyText, isdwld, text, title, shareCon, extval)
  }
  if (text.includes("Action Items") && actionsData) {
    actionsData.forEach((element: any) => {
      bodyText += element.name + ":\r\n" +
        "\t" + element.actions + "\r\n";
    });
    textConvert(bodyText, isdwld, text, title, shareCon, extval)
  }
}

export const textConvert = (text: any, dwld: any, formlen: any, title: any, shareCon?: any, extval?: any) => {

  textfile = new Blob([text], { type: 'text/plain' });
  blobArr.push(textfile);
  if (formlen.length === blobArr.length && formlen.length > 1 && dwld === "download") {
    zipFile(blobArr, "txt", title);
  }
  if (dwld === "download" && formlen.length === 1) { saveAs(textfile, `${title}.txt`); }
  if (dwld === "share" || dwld === "external") { shareFile(blobArr, formlen, shareCon, `${title}.txt`, extval, dwld) }
}



export const outlook = async (files: any) => {
  var str = files;
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  const subject = " download Links";

  let alt_des: any = str.length === 1 ? str[0].geturl : str.length === 2 ? str[0].geturl + `\n\n` + str[1].geturl : str[0].geturl + `\n\n` + str[1].geturl + `\n\n` + str[2].geturl;
  let transcriptInfo = {
    'altDescription': loggedUserDetails["caller_id"] + " has shared meeting summary links \n\n" +
      "Title : " + detailPage.title + ' \n\n' +
      "Meeting Summary Links : " + alt_des + ' \n\n' +
      "Meeting-ID : " + detailPage.meeting_id
  };
  let url = encodeURI(`https://outlook.live.com/owa/?path=/mail/action/compose&to=&subject=${subject}&body=${transcriptInfo.altDescription}`);

  window.open(url, '_blank');
}

export const textToWord = (text: any, isDownload: any, title: any, shareCon?: any, extval?: any) => {
  let bodyText: any = '';
  let { transcript, meetingHighlights,actionsData } = store.getState().meetingReducer;
  let { originalMOM, part_MOM } = store.getState().meetingReducer;
  if (text.includes("Transcript") && transcript) {
    transcript.forEach((element: any) => {
      bodyText += '<div style="color:#6B7280;font-size: 20px;font-family: intersemibold">' + element.name.toUpperCase().charAt(0) + '</div>';
      bodyText += '<div style="font-size: 14px;font-family: intermedium">' + element.name +
        '<span style=" margin-left: 150px;font-size: 11px;color: #4B5563;line-height: 17px;position: relative;">'
        + moment(element.time).format('hh:mm a') + '</span>' + '</div>';
      bodyText += '<div style=" margin-left: 40px;font-size: 11px;color: #4B5563;line-height: 17px;position: relative;">' + element.text + '</div>';
    });
    wordConvert(bodyText, isDownload, text, title, shareCon, extval);
  }
  if (text.includes("Summary") && originalMOM && part_MOM) {
    originalMOM.forEach((element: any) => {
      bodyText += '<div style="color:#6B7280;font-size: 20px;font-family: intersemibold">' + element.name + '</div>';
      bodyText += '<ul><li>' + element.summary + '</li></ul>';
    });
    bodyText += '<div style="color:#6B7280;font-size: 20px;font-family: intersemibold">' + `Participant Summary` + '</div>';

    part_MOM.forEach((element: any) => {
      bodyText += '<div style="color:#6B7280;font-size: 20px;font-family: intersemibold">' + element.name + '</div>';
      bodyText += '<ul><li>' + element.summary + '</li></ul>';
    })
    wordConvert(bodyText, isDownload, text, title, shareCon, extval);
    bodyText = "";
  }
  if (text.includes("Highlight") && meetingHighlights) {
    meetingHighlights.forEach((element: any) => {
      bodyText += '<div style="font-size: 14px;font-family: intermedium">' + element.name +
        '<span style=" margin-left: 150px;font-size: 11px;color: #4B5563;line-height: 17px;position: relative;">'
        + moment(element.timeStamp).format('hh:mm a') + '</span>' + '</div>';
      bodyText += '<div style=" margin-left: 40px;font-size: 11px;color: #4B5563;line-height: 17px;position: relative;">' + element.summary + '</div>';
    });
    wordConvert(bodyText, isDownload, text, title, shareCon, extval);
    bodyText = "";
  }
  if (text.includes("Action Items") && actionsData) {
    actionsData.forEach((element: any) => {
      bodyText += '<div style="font-size: 14px;font-family: intermedium">' + element.name +
        '<span style=" margin-left: 150px;font-size: 11px;color: #4B5563;line-height: 17px;position: relative;">'
        + moment(element.timeStamp).format('hh:mm a') + '</span>' + '</div>';
      bodyText += '<div style=" margin-left: 40px;font-size: 11px;color: #4B5563;line-height: 17px;position: relative;">' + element.summary + '</div>';
    });
    wordConvert(bodyText, isDownload, text, title, shareCon, extval);
    bodyText = "";
  }
}
export const wordConvert = (bodyText: any, dwnld?: any, formatlen?: any, title?: any, shareCon?: any, extval?: any) => {
  var HtmlHead = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
    "<head><meta charset='utf-8'><title></title></head><body>";
  var EndHtml = "</body></html>";
  var html = HtmlHead + bodyText + EndHtml;
  const htmlCon = `<html><body>${bodyText}</body></html>`;
  const blob = new Blob([htmlCon], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
  var url = 'data:application/msword;charset=utf-8,' + encodeURIComponent(html);
  var wordBlob: any = DataURIToBlob(url);
  blobArr.push(blob);
  if (formatlen.length === blobArr.length && formatlen.length > 1 && dwnld === "download") {
    zipFile(blobArr, "doc", title);
  }
  let filename = `${title}.doc`;
  if (dwnld === "download" && formatlen.length === 1) {
    var downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.href = url;
    downloadLink.download = filename;
    downloadLink.click();
    document.body.removeChild(downloadLink);
    blobArr = [];
  }
  if (dwnld === "share" || dwnld === "external") {
    shareFile(blobArr, formatlen, shareCon, filename, extval, dwnld)

  }
}
export const textToPdf = (text: any, download?: any, title?: any, shareCon?: any, extval?: any) => {
  let { transcript, meetingHighlights, part_MOM, editMOM,actionsData } = store.getState().meetingReducer;
  let bodyText: any = "";
  if (text.includes("Transcript") && transcript) {
    transcript.forEach((element: any) => {
      bodyText += '<div style="width: 100%;"><span style="font-size: 10px;white-space: nowrap;">' + element.name + '</span>' + ':' + '<span style="display: inline-block;width: 450px;font-size: 10px;color: #4B5563;">' + element.text + '</span></div></br>';
    });
    textToPdfBlob(bodyText, download, text, title, shareCon, extval)
    bodyText = "";
  }
  if (text.includes("Summary")) {
    bodyText += '<div style="width: 100%;"><span style="font-size: 10px;white-space: nowrap;">' + `Overall Summary` + '</span>';
    bodyText += '<span style="display:inline-block;width: 450px;">' + editMOM + '</span>' + '\r\n';
    bodyText += '<div style="width: 100%;"><span style="font-size: 10px;white-space: nowrap;">' + `Participant Summary` + '</span>';
    part_MOM.forEach((element: any) => {
      bodyText += '<div style="width: 100%;"><span style="font-size: 10px;white-space: nowrap;">' + element.name + '</span>' + ':' + '<span style="display:inline-block;font-size: 10px;color: #4B5563;width: 450px;">' + element.summary + '</span></div></br>';
    })
    textToPdfBlob(bodyText, download, text, title, shareCon, extval)
    bodyText = "";
  }
  if (text.includes("Highlight") && meetingHighlights) {
    meetingHighlights.forEach((element: any) => {

      bodyText += '<div style="width: 100%;"><span style="font-size: 10px;white-space: nowrap;">' + element.name + '</span>' + ':' + '<span style="display: inline-block;width: 450px;font-size: 10px;color: #4B5563;">' + element.summary + '</span></div></br>';
    });
    textToPdfBlob(bodyText, download, text, title, shareCon)
    bodyText = "";
  }
  if (text.includes("Action Items") && actionsData) {
    actionsData.forEach((element: any) => {

      bodyText += '<div style="width: 100%;"><span style="font-size: 10px;white-space: nowrap;">' + element.name + '</span>' + ':' + '<span style="display: inline-block;width: 450px;font-size: 10px;color: #4B5563;">' + element.actions + '</span></div></br>';
    });
    textToPdfBlob(bodyText, download, text, title, shareCon)
    bodyText = "";
  }

}

export const shareFile = (file: any, formlen?: any, shareConatct?: any, title?: any, extval?: any, dwld?: any) => {

  var str = title;
  str = str?.replace(/\s+/g, '_');
  const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;
  let token: any = getCookie("ssoToken");
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };

  let formData = new FormData();

  file.forEach((elem: any) => {
    formData.append("doc", elem, str);
    axios
      .post(url, formData, { headers: authkey })
      .then((response: any) => {
        if (dwld === "share") {
          if (response.data.files.length === formlen.length) {
            finalShare(response?.data?.files, shareConatct, str)
            blobArr = [];
          }
        }

        else {
          if (response.data.files.length === formlen.length) {
            if (extval === "Outlook") {
              outlook(response?.data?.files);
              blobArr = [];
            }
            else {
              gmail(response?.data?.files);
              blobArr = [];
            }
          }
        }
      })
      .catch((err: any) => {
        console.log("err---", err);
      });
  })
}

export const setAiAssist=(val:any,val1:any,str:string,callList:any)=>{
store.dispatch({
  type:Types.AI_ASSIST,
  payload:{
    isAiAssist:val,
    isCaptureAi:val1,
    aiRequest:str,
    list:callList
  }
})
}

export const handleStartRecording = async () => {
  try {
      const {aiSessionId,isAiAssist,isCaptureAi}:any=store.getState().chatReducer;
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      let audioChunksRef:any=[];
       mediaRecorder = new MediaRecorder(stream);
       const audioContext = new (window.AudioContext || window.webkitAudioContext)();

      mediaRecorder.ondataavailable = (event: BlobEvent) => {
          if (event.data.size > 0) {
              audioChunksRef.push(event.data);
          }
      };

      mediaRecorder.onstop = async () => {
const audioBlob = new Blob(audioChunksRef, { type: 'audio/wav' });

audioChunksRef = [];
mediaRecorder.ondataavailable = null;
mediaRecorder = null;   
const audioContext = new (window.AudioContext || window.webkitAudioContext)();
const arrayBuffer = await audioBlob.arrayBuffer();
const buff:any=arrayBuffer.slice(0);
const audioBuffer = await audioContext.decodeAudioData(buff);
const rawData = audioBuffer.getChannelData(0);
let sum = 0.0;
for (let i = 0; i < rawData.length; i++) {
  sum += rawData[i] * rawData[i];
}
const rms = Math.sqrt(sum / rawData.length);
          if (rms > 0.03) {
    if(isCaptureAi){let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
    const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
    let data:any={
      "sessionId":aiSessionId,
      "audioFile":arrayBuffer,
      "sip_id":loggeduser.sip_login_id
    }
    socketservice.aiSuggestions(data);}
      }
      else{
      // setTimeout(()=>{
        setAiAssist(isAiAssist,isCaptureAi,'Listening...',{suggestions:[],prompt:"",error:""})
        handleStartRecording();
      // },3000)
      }
    }

      mediaRecorder.start(1000);
      setTimeout(() => {
       handleStopRecording();
    }, 5000)
  } catch (error) {
      console.error('Error accessing the microphone:', error);
  }
};

export const redirect=(ele:any)=>{
 window.open(ele.url, '_blank'); 
 store.dispatch({
  type: Types.VIDEOMEET_COUNT_STATUS,
  payload: {
    meetingCountStatus:true
  }
})
updateMeetingRead(ele?.uuid);
setAiAssist(false,false,"", {suggestions:[],prompt:"",error:""});
}

export const handleStopRecording = () => {
  if (mediaRecorder) {
      mediaRecorder.stop();
  }
};

const gmail = (files: any) => {
  let { detailPage } = store.getState().meetingReducer;
  var str = files[0]?.geturl;
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  const subject = "Transcription download Links";
  const alt = files;
  let alt_des: any = alt.length === 1 ? alt[0].geturl : alt.length === 2 ? alt[0].geturl + `\n\n` + alt[1].geturl : alt[0].geturl + `\n\n` + alt[1].geturl + `\n\n` + alt[2].geturl;
  let transcriptInfo = {
    'altDescription': loggedUserDetails["caller_id"] + " has shared meeting summary links \n\n" +
      "Title : " + detailPage.title + ' \n\n' +
      "Meeting Summary Links : " + alt_des + `\n\n` +
      "Meeting-ID : " + detailPage.meeting_id
  };
  const generateURL = encodeURI(`https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&su=${subject}&body=${transcriptInfo.altDescription}`);
  window.open(generateURL, '_blank');
}


export const finalShare = (files: any, shareContact?: any, title?: any, msg?: string) => {
  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  let { allContacs }: contacts = store.getState().contactReducer;
  for(let i=0;i<shareContact.length;i++)
  {
      if(shareContact[i].chattype !== "group")
      {
        // shareContact.forEach((value: any) => {
          files.forEach((elem: any) => {
            socketChat.newMessageFileAttach(title, elem.mimetype, elem.size, elem.geturl, shareContact[i], false, "");
          })
        // })
      }
      else{
        // shareContact.forEach((value: any) => {
          files.forEach((elem: any) => {
            let finalReceiver:any = allContacs?.find((List: any) => List?.team_id && List?.team_id.toString() === shareContact[i].team_id);
            socketChat.sendFileToGroup(files[0], finalReceiver, true);
          })
        // })
      }
  }
 
  updateCCToast("File Shared Successfully");
  blobArr = [];
}

export const copyLink = (text: any) => {
  if (text.clip_Url) {
    navigator.clipboard.writeText(text.clip_Url);
    toastInformation('Video link was copied', "success");
  }
  else{
    navigator.clipboard.writeText(text.record_url);
    toastInformation('Video link was copied', "success");
  }
};

export const downloadFile = (file: any) => {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", file?.record_url, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = file?.meeting_name;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
  toastInformation('Video Downloaded Successfully', "success");
}

export const textToPdfBlob = (bodyText: any, dwld?: any, formatlen?: any, title?: any, shareContact?: any, extval?: any) => {
  let downloadUrl: any;
  var doc = new jsPDF({
    orientation: 'portrait',
    unit: 'pt'
  });
  const result = doc.html(bodyText, {
    margin: [80, 100, 100, 100],
    callback: async function (doc: any) {
      let pdfurl: string = doc.output("dataurlstring");

      downloadUrl = DataURIToBlob(pdfurl)

      blobArr.push(downloadUrl);

      if (formatlen?.length === blobArr?.length && formatlen?.length > 1 && dwld === "download") {
        zipFile(blobArr, "pdf", title);
        blobArr = [];
      }
      let filename = `${title}.pdf`;
      if (dwld === "download" && formatlen?.length === 1) {
        var downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        downloadLink.href = pdfurl;
        downloadLink.download = filename;
        downloadLink.click();
        document.body.removeChild(downloadLink);
        blobArr = [];
      }
      if ((dwld === "share" || dwld === "external") && formatlen?.length === blobArr?.length) {
        shareFile(blobArr, formatlen, shareContact, filename, extval, dwld)
      }
    }
  });
}

export const textToPdfBlobVMtrans = (bodyText: string, title: string = "Voicemail") => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "pt",
    format: "a4"
  });

  const marginLeft = 40;
  const marginTop = 60;
  const maxWidth = 520;

  doc.setFontSize(12);
  doc.text("Voicemail Transcript", marginLeft, marginTop);

  doc.setFontSize(10);
  doc.setTextColor(75);
  doc.text(doc.splitTextToSize(bodyText, maxWidth), marginLeft, marginTop + 30);

  doc.save(`${title}.pdf`);
};



export const zipFile = (val: any, format: any, title: any) => {
  var count = 0;

  val.forEach((elem: any) => {
    zip.file(`${title} ${count + 1}.${format}`, elem);
    count++;
  })

  if (count === val.length) {
    zip.generateAsync({ type: 'blob' }).then(function (content: any) {
      saveAs(content, `${title}.zip`);
    });
    blobArr = [];
  }
}

export const copyCC = () => {
  let { ccTab, part_MOM, transcript, editMOM, meetingHighlights,actionsData } = store.getState().meetingReducer;
  let key: any = "";
  let { keywords } = store.getState().meetingReducer;
  if (ccTab === "2" && keywords) {
    key += `keywords :`;
    keywords.forEach((elem: any) => {
      key += elem + `,`;
    })

    navigator.clipboard.writeText(key);
    updateCCToast("Meeting keyword Copied");
  }
  if (ccTab === "4" && meetingHighlights) {
    let str: any = '';
    meetingHighlights.forEach((element: any) => {

      str += element.name + ":\r\n" +
        "\t" + element.summary + "\r\n";
    });

    navigator.clipboard.writeText(str);
    updateCCToast("Meeting Highlights Copied");
  }
  else if (ccTab === "1" && editMOM && part_MOM) {
    let str = ""
    let part: any = "";
    let final: any = "";


    str +=
      editMOM + "\r\n";

    part_MOM?.forEach((element: any) => {
      part += element.name + ":\r\n" +
        "\t" + element.summary + "\r\n" + '\n\n';

    })
    final += `Overall Summary \n\n` +
      str + '\n\n' +
      `Participant summary \n\n` +
      part + '\n\n';

    navigator.clipboard.writeText(final);
    updateCCToast("Meeting Summary Copied");
  }

  else if (ccTab === "3" && transcript) {
    let str: any = '';
    transcript.forEach((element: any) => {

      str += element.name + ":\r\n" +
        "\t" + element.text + "\r\n";
    });

    navigator.clipboard.writeText(str);
    toastInformation("Meeting Transcript Copied");
  }
  else if (ccTab === "5" && actionsData) {
    let str: any = '';
    actionsData.forEach((element: any) => {

      str += element.name + ":\r\n" +
        "\t" + element.actions + "\r\n";
    });

    navigator.clipboard.writeText(str);
    toastInformation("Meeting Actions Copied");
  }
}
export const accpectApiVideoInvite = (data: any, param: any) => {
  let token: any = getCookie("ssoToken");
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };
  let urlParam: any = "";
  if (param === "joined") {
    urlParam = `${config().MEET_RESTAPI_URL}/joined_meet`;
    let replaced_url: any = data.meetingDetails.inviteUrl?.includes("stagemeet") ?
      `${data.meetingDetails.inviteUrl}?type=meetnow` : `${data.meetingDetails.inviteUrl?.replace('meet.unifiedring', 'meet.worktual')}?type=meetnow`;
    window.open(replaced_url, '_blank');
    closeVideoCallRinging();
  }
  else {
    urlParam = `${config().MEET_RESTAPI_URL}/rejected_meet`
    closeVideoCallRinging();
  }
  axios
    .post(urlParam, data, { headers: authkey })
    .then((response: any) => {
      if (response.data && response.data.statusCode === 200) {

      }
    });
}

export const videoCallReqNotfy = (type:any,msg?:any) => {
  const {directVmCallCount}:any=store.getState().profileReducer;
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
 if(type ==="accept"){ closeVideoCallRinging();
  store.dispatch({
    type: Types.VIDEO_CALL_REQUEST_SENT,
    payload: {
      isVideoRequestSent: false,
      meetingDetails: {}
    }
  })

  store.dispatch({
    type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
    payload: {
      meetingDetails: {},
      isVideocallRingvideo: false,
      isDirectVideocall: false
    }
  })
  store.dispatch({
    type: Types.VIDEO_CALL_REQ_COUNT,
    payload: {
        directVmCallCount:0
    }
  })}
  else{
   let host_det: any = msg.meetingDetails.participants.find((ele: any) => { return ele.roletype === 1 })
   if (msg.sipId.includes(host_det.sipid) && msg.sipId.length === 1 && host_det.sipid === loggedUserDetails.sip_login_id){
     if (msg.meetingDetails.participants.length-1 !== directVmCallCount + 1) {
       store.dispatch({
         type: Types.VIDEO_CALL_REQ_COUNT,
         payload: {
             directVmCallCount: directVmCallCount + 1
         }
       })

     }
     else{
      store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_SENT,
        payload: {
          isVideoRequestSent: false,
          meetingDetails: {}
        }
      })
    
      store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
        payload: {
          meetingDetails: {},
          isVideocallRingvideo: false,
          isDirectVideocall: false
        }
      })
      store.dispatch({
        type: Types.VIDEO_CALL_REQ_COUNT,
        payload: {
            directVmCallCount:0
        }
      })
     }
  }
  else{
    closeVideoCallRinging();
    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_SENT,
      payload: {
        isVideoRequestSent: false,
        meetingDetails: {}
      }
    })
  
    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
      payload: {
        meetingDetails: {},
        isVideocallRingvideo: false,
        isDirectVideocall: false
      }
    }) 
    store.dispatch({
      type: Types.VIDEO_CALL_REQ_COUNT,
      payload: {
          directVmCallCount:0
      }
    })
  }
}
}

export const getDuration = (list: any) => {
  if (!_.isEmpty(list)) {
    const [hours, mints, seconds] = list?.split(":").map(parseFloat);
    return `${hours !== 0 ? `${Math.round(hours)}h` : ""} ${mints !== 0 ? `${Math.round(mints)}m` : ""} ${Math.round(seconds)}s`;
  }
}

export const VideoRecordDelete = (data:any) => {
  let recdata: any = {};
  recdata.unique_id = data;
  deleteRecord(recdata)
}

export const meetingCountStatus =(data:any) =>{

store.dispatch({
  type: Types.VIDEOMEET_COUNT_STATUS,
  payload: {
    meetingCountStatus:data
  }
})
}

export function getLocalAudioStream() {
  return navigator.mediaDevices.getUserMedia({ audio: true })
    .then(function(stream) {
      const audioStream = new MediaStream();
      const audioTrack = stream.getAudioTracks()[0];
      audioStream.addTrack(audioTrack);
      return audioStream;
    });
}
export const clipsDelete=(data:any)=>{
  let token: string = store.getState().loginReducer.token;
  const {recordDetailPage}=store.getState().meetingReducer;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };
  axios.delete(`${config().MEET_RESTAPI_URL}/delete_recording_clip`,  {data:data,
  headers:authkey})
  .then((response: any) => {
    if (response) {
       fetchClips(recordDetailPage.meeting_id);
       toastInformation('Clips Deleted successfully');
    }
  })


} 
export const getWorktualAccess = async (company_id: any) => {
  const input = {
    "company_id": company_id
  };

  let sites:any = [];
  try {
    const response = await axios.post(config().PURCHASED_ACCESS, input, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const resultAccess = response.data;
    if (resultAccess?.statusCode === 0) {
      resultAccess.result.forEach((access:any) => {
        sites.push({ productName: access.prd_name });
      });
    }
  } catch (error) {
    console.error(error);
  }

  return sites;
};

export const editMeetName=(data:any)=>{
  let token: string = store.getState().loginReducer.token;
  const {recordDetailPage,currentWindowState}=store.getState().meetingReducer;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };
  axios.post(`${config().MEET_RESTAPI_URL}/update_recording_info`,data,{headers:authkey})
  .then((response: any) => {
    if (response) {
      if (recordDetailPage) {
        let updatedInfo: any = recordDetailPage;
        updatedInfo = {
            ...updatedInfo, meeting_name:data.meeting_name
        };
        saverecordlist(updatedInfo);
    }
    }
  })
}

export const RecordClipsDelete=(data:any)=>{
  let token: string = store.getState().loginReducer.token;
  let{recordDetailPage}=store.getState().meetingReducer;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };

  axios.delete(`${config().MEET_RESTAPI_URL}/delete_recording_clip`, {
    headers: authkey,
    data: {clip_record_id:data}
  })
  .then((response: any) => {
    if (response) { 
       fetchClips(recordDetailPage.meeting_id);
       toastInformation('Clips Deleted successfully');
    }
  }).catch((error)=>{
    console.log(error)
  })
}

export const playListDelete=(data:any)=>{
  let token: string = store.getState().loginReducer.token;
  const {recordDetailPage}=store.getState().meetingReducer;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };
  axios.delete(`${config().MEET_RESTAPI_URL}/delete_playlist/${data} `,  
  {headers:authkey})
  .then((response: any) => {
    if (response) {
      fetchPlayLists();
       toastInformation('PlayList Deleted successfully');
    }
  })


} 

export const storePlanValues = ()=>{
  let token: string = store.getState().loginReducer.token;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };
  axios.get(`${config().CHAT_RESTAPI_URL}/administration/paln_based_details`,{headers:authkey})
  .then((response: any) => {
    if (response) {
    //  console.log("planBased--response ok",response?.data?.result)
     storePlanBasedFeatures(response?.data?.result);
    }
  }) 
}
export const storePlanBasedFeatures =(data:any) =>{
  store.dispatch({
    type: Types.PLAN_BASED_FEATURE,
    payload: { planBased: data }
  });

}
